import { ticCreateApiBase as api } from "../../../../api/core/tic/tic.createApi.base";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMemoryConfig: build.query<GetMemoryConfigApiResponse, GetMemoryConfigApiArg>({
      query: () => ({ url: `/1.0/memories/filters` }),
    }),
    saveMemoryConfig: build.mutation<SaveMemoryConfigApiResponse, SaveMemoryConfigApiArg>({
      query: (queryArg) => ({ url: `/1.0/memories/filters`, method: "POST", body: queryArg.body }),
    }),
    getMemories: build.query<GetMemoriesApiResponse, GetMemoriesApiArg>({
      query: (queryArg) => ({
        url: `/1.0/memories`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          limit: queryArg.limit,
          page: queryArg.page,
        },
      }),
    }),
    deleteMemories: build.mutation<DeleteMemoriesApiResponse, DeleteMemoriesApiArg>({
      query: (queryArg) => ({ url: `/1.0/memories`, method: "DELETE", body: queryArg.body }),
    }),
    getAiPredictionsInDateRange: build.query<
      GetAiPredictionsInDateRangeApiResponse,
      GetAiPredictionsInDateRangeApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/ai/predictions/time-intervals`,
        params: {
          started_at: queryArg.startedAt,
          ended_at: queryArg.endedAt,
          timely_account_id: queryArg.timelyAccountId,
          user_id: queryArg.userId,
          apply_rejections: queryArg.applyRejections,
        },
      }),
    }),
    rejectAiPrediction: build.mutation<RejectAiPredictionApiResponse, RejectAiPredictionApiArg>({
      query: (queryArg) => ({
        url: `/1.0/ai/predictions/time-intervals/reject`,
        method: "DELETE",
        body: queryArg.body,
      }),
    }),
    getAiPredictionStatusForDateRange: build.query<
      GetAiPredictionStatusForDateRangeApiResponse,
      GetAiPredictionStatusForDateRangeApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/ai/predictions/status`,
        params: {
          from_date: queryArg.fromDate,
          to_date: queryArg.toDate,
          timely_user_id: queryArg.timelyUserId,
          timely_account_id: queryArg.timelyAccountId,
        },
      }),
    }),
    setAiPredictionStatus: build.mutation<
      SetAiPredictionStatusApiResponse,
      SetAiPredictionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/ai/prediction_logs`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    refreshAiPredictionsInDateRange: build.mutation<
      RefreshAiPredictionsInDateRangeApiResponse,
      RefreshAiPredictionsInDateRangeApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/ai/predictions/refresh`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    retrainAiModel: build.mutation<RetrainAiModelApiResponse, RetrainAiModelApiArg>({
      query: (queryArg) => ({
        url: `/1.0/ai/preferences/retrain-model`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    resetAiModel: build.mutation<ResetAiModelApiResponse, ResetAiModelApiArg>({
      query: (queryArg) => ({
        url: `/1.0/ai/preferences/reset-model`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    requestHourNoteGeneration: build.mutation<
      RequestHourNoteGenerationApiResponse,
      RequestHourNoteGenerationApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/ai/generate_note/hour`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    requestSuggestionNoteGeneration: build.mutation<
      RequestSuggestionNoteGenerationApiResponse,
      RequestSuggestionNoteGenerationApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/ai/generate_note/suggestion`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAiPreferences: build.query<GetAiPreferencesApiResponse, GetAiPreferencesApiArg>({
      query: () => ({ url: `/1.0/predictions/preferences` }),
    }),
    saveAiPreferences: build.mutation<SaveAiPreferencesApiResponse, SaveAiPreferencesApiArg>({
      query: (queryArg) => ({
        url: `/1.0/predictions/preferences`,
        method: "POST",
        body: queryArg.body,
        params: {
          timely_account_id: queryArg.timelyAccountId,
          side_effect: queryArg.sideEffect,
        },
      }),
    }),
    getAiWorkspacePreferences: build.query<
      GetAiWorkspacePreferencesApiResponse,
      GetAiWorkspacePreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/predictions/workspace_preferences`,
        params: {
          timely_account_id: queryArg.timelyAccountId,
        },
      }),
    }),
    saveAiWorkspacePreferences: build.mutation<
      SaveAiWorkspacePreferencesApiResponse,
      SaveAiWorkspacePreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/predictions/workspace_preferences`,
        method: "POST",
        body: queryArg.body,
        params: {
          timely_account_id: queryArg.timelyAccountId,
        },
      }),
    }),
    getAiWorkspaceDefaults: build.query<
      GetAiWorkspaceDefaultsApiResponse,
      GetAiWorkspaceDefaultsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/predictions/workspace_defaults`,
        params: {
          timely_account_id: queryArg.timelyAccountId,
        },
      }),
    }),
    saveAiWorkspaceDefaults: build.mutation<
      SaveAiWorkspaceDefaultsApiResponse,
      SaveAiWorkspaceDefaultsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/predictions/workspace_defaults`,
        method: "POST",
        body: queryArg.body,
        params: {
          timely_account_id: queryArg.timelyAccountId,
        },
      }),
    }),
    getAssistantResponse: build.query<GetAssistantResponseApiResponse, GetAssistantResponseApiArg>({
      query: (queryArg) => ({
        url: `/1.0/agent`,
        params: {
          message: queryArg.message,
          timely_account_id: queryArg.timelyAccountId,
          session_id: queryArg.sessionId,
        },
      }),
    }),
    resetEverythingAi: build.mutation<ResetEverythingAiApiResponse, ResetEverythingAiApiArg>({
      query: (queryArg) => ({ url: `/1.0/ai/reset`, method: "POST", body: queryArg.body }),
    }),
    getTools: build.query<GetToolsApiResponse, GetToolsApiArg>({
      query: (queryArg) => ({
        url: `/1.0/tools`,
        params: {
          accountId: queryArg.accountId,
          scope: queryArg.scope,
          onlyConnected: queryArg.onlyConnected,
          onlyProviders: queryArg.onlyProviders,
          earlyAdopter: queryArg.earlyAdopter,
        },
      }),
    }),
    getToolId: build.query<GetToolIdApiResponse, GetToolIdApiArg>({
      query: (queryArg) => ({
        url: `/1.0/tools/${queryArg.toolId}`,
        params: {
          accountId: queryArg.accountId,
        },
      }),
    }),
    getToolConfigs: build.query<GetToolConfigsApiResponse, GetToolConfigsApiArg>({
      query: () => ({ url: `/1.0/tool/configs` }),
    }),
    resetAllToolConfigs: build.mutation<ResetAllToolConfigsApiResponse, ResetAllToolConfigsApiArg>({
      query: () => ({ url: `/1.0/tool/configs`, method: "DELETE" }),
    }),
    getDefaultToolConfigs: build.query<
      GetDefaultToolConfigsApiResponse,
      GetDefaultToolConfigsApiArg
    >({
      query: () => ({ url: `/1.0/tool/configs/defaults` }),
    }),
    saveToolConfig: build.mutation<SaveToolConfigApiResponse, SaveToolConfigApiArg>({
      query: (queryArg) => ({
        url: `/1.0/tool/config`,
        method: "PUT",
        body: queryArg.body,
        params: {
          toolId: queryArg.toolId,
          toolRaw: queryArg.toolRaw,
        },
      }),
    }),
    deleteToolConfig: build.mutation<DeleteToolConfigApiResponse, DeleteToolConfigApiArg>({
      query: (queryArg) => ({
        url: `/1.0/tool/config`,
        method: "DELETE",
        params: {
          toolId: queryArg.toolId,
          toolRaw: queryArg.toolRaw,
        },
      }),
    }),
    updateBatchOfSubscriptions: build.mutation<
      UpdateBatchOfSubscriptionsApiResponse,
      UpdateBatchOfSubscriptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/integrations/${queryArg.provider}/config/subscriptions/batch/update`,
        method: "POST",
        body: queryArg.body,
        params: {
          accountId: queryArg.accountId,
          connectionId: queryArg.connectionId,
        },
      }),
    }),
    getSubscribableResources: build.query<
      GetSubscribableResourcesApiResponse,
      GetSubscribableResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/integrations/${queryArg.provider}/config/subscriptions`,
        params: {
          accountId: queryArg.accountId,
          connectionId: queryArg.connectionId,
        },
      }),
    }),
    providerOperationId: build.mutation<ProviderOperationIdApiResponse, ProviderOperationIdApiArg>({
      query: (queryArg) => ({
        url: `/1.0/integrations/${queryArg.provider}/${queryArg.operationId}`,
        method: "GET",
        params: {
          connectionId: queryArg.connectionId,
          nangoConnectionId: queryArg.nangoConnectionId,
          currentTimelyAccountId: queryArg.currentTimelyAccountId,
          executionMode: queryArg.executionMode,
          forceFullImport: queryArg.forceFullImport,
          generateDiffAfterSync: queryArg.generateDiffAfterSync,
          urlOrPath: queryArg.urlOrPath,
        },
      }),
    }),
    getIntegrations: build.query<GetIntegrationsApiResponse, GetIntegrationsApiArg>({
      query: (queryArg) => ({
        url: `/2.0/integrations/list`,
        params: {
          accountId: queryArg.accountId,
        },
      }),
    }),
    getIntegrationDetails: build.query<
      GetIntegrationDetailsApiResponse,
      GetIntegrationDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.providerId}/details`,
        params: {
          accountId: queryArg.accountId,
        },
      }),
    }),
    finalizeIntegrationSetup: build.mutation<
      FinalizeIntegrationSetupApiResponse,
      FinalizeIntegrationSetupApiArg
    >({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/finalize-setup`,
        method: "POST",
        body: queryArg.body,
        params: {
          connectionId: queryArg.connectionId,
        },
      }),
    }),
    getDiffPreview: build.query<GetDiffPreviewApiResponse, GetDiffPreviewApiArg>({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.providerId}/diff_preview`,
        params: {
          connectionId: queryArg.connectionId,
          timelyAccountId: queryArg.timelyAccountId,
          format: queryArg.format,
          resourceTypes: queryArg.resourceTypes,
        },
      }),
    }),
    regenerateFullDiff: build.mutation<RegenerateFullDiffApiResponse, RegenerateFullDiffApiArg>({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/regenerate-full-diff`,
        method: "POST",
        body: queryArg.body,
        params: {
          connectionId: queryArg.connectionId,
          resourceTypes: queryArg.resourceTypes,
        },
      }),
    }),
    getConnectionJobs: build.query<GetConnectionJobsApiResponse, GetConnectionJobsApiArg>({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/connections/${queryArg.connectionId}/jobs`,
        params: {
          includeRecent: queryArg.includeRecent,
        },
      }),
    }),
    getConnectionSyncRunProgress: build.query<
      GetConnectionSyncRunProgressApiResponse,
      GetConnectionSyncRunProgressApiArg
    >({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/connections/${queryArg.connectionId}/sync-run-progress`,
      }),
    }),
    getConnectionSyncRuns: build.query<
      GetConnectionSyncRunsApiResponse,
      GetConnectionSyncRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/connections/${queryArg.connectionId}/sync-runs`,
      }),
    }),
    getDiffsList: build.query<GetDiffsListApiResponse, GetDiffsListApiArg>({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/diffs`,
        params: {
          connectionId: queryArg.connectionId,
          page: queryArg.page,
          perPage: queryArg.perPage,
        },
      }),
    }),
    getDiffDetails: build.query<GetDiffDetailsApiResponse, GetDiffDetailsApiArg>({
      query: (queryArg) => ({
        url: `/2.0/integrations/${queryArg.provider}/diffs/${queryArg.diffId}`,
        params: {
          connectionId: queryArg.connectionId,
          format: queryArg.format,
        },
      }),
    }),
    updateConnectionId: build.mutation<UpdateConnectionIdApiResponse, UpdateConnectionIdApiArg>({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    resetConnectionId: build.mutation<ResetConnectionIdApiResponse, ResetConnectionIdApiArg>({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/reset`,
        method: "POST",
      }),
    }),
    disconnectConnectionId: build.mutation<
      DisconnectConnectionIdApiResponse,
      DisconnectConnectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/disconnect`,
        method: "DELETE",
      }),
    }),
    deleteConnectionId: build.mutation<DeleteConnectionIdApiResponse, DeleteConnectionIdApiArg>({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/delete`,
        method: "DELETE",
      }),
    }),
    getConnectionActivities: build.query<
      GetConnectionActivitiesApiResponse,
      GetConnectionActivitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/connection/activities`,
        params: {
          connectionId: queryArg.connectionId,
          toolId: queryArg.toolId,
          accountId: queryArg.accountId,
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    getConnectionWebhooks: build.query<
      GetConnectionWebhooksApiResponse,
      GetConnectionWebhooksApiArg
    >({
      query: (queryArg) => ({ url: `/1.0/connections/${queryArg.connectionId}/webhooks` }),
    }),
    takeoverWebhooks: build.mutation<TakeoverWebhooksApiResponse, TakeoverWebhooksApiArg>({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/webhooks/takeover`,
        method: "POST",
      }),
    }),
    getConnectionProviderCustomSettingsFields: build.query<
      GetConnectionProviderCustomSettingsFieldsApiResponse,
      GetConnectionProviderCustomSettingsFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/provider/custom-settings-fields`,
      }),
    }),
    reinstallConnectionWebhooks: build.mutation<
      ReinstallConnectionWebhooksApiResponse,
      ReinstallConnectionWebhooksApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/connections/${queryArg.connectionId}/webhooks/reinstall`,
        method: "POST",
      }),
    }),
    getResourcesByType: build.query<GetResourcesByTypeApiResponse, GetResourcesByTypeApiArg>({
      query: (queryArg) => ({
        url: `/1.0/resources/type/${queryArg.resourceType}`,
        params: {
          accountId: queryArg.accountId,
          connectionId: queryArg.connectionId,
          page: queryArg.page,
          limit: queryArg.limit,
          orderBy: queryArg.orderBy,
          orderDirection: queryArg.orderDirection,
          search: queryArg.search,
          toolId: queryArg.toolId,
          ids: queryArg.ids,
          uris: queryArg.uris,
        },
      }),
    }),
    getTasks: build.query<GetTasksApiResponse, GetTasksApiArg>({
      query: (queryArg) => ({
        url: `/1.0/resources/tasks`,
        params: {
          accountId: queryArg.accountId,
          search: queryArg.search,
          toolId: queryArg.toolId,
          includeDeleted: queryArg.includeDeleted,
          limit: queryArg.limit,
          page: queryArg.page,
        },
      }),
    }),
    searchTasks: build.mutation<SearchTasksApiResponse, SearchTasksApiArg>({
      query: (queryArg) => ({
        url: `/1.0/resources/tasks/search`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getNotifications: build.query<GetNotificationsApiResponse, GetNotificationsApiArg>({
      query: (queryArg) => ({
        url: `/1.0/notifications`,
        params: {
          account_id: queryArg.accountId,
          user_id: queryArg.userId,
          personal_account_id: queryArg.personalAccountId,
          notification_id: queryArg.notificationId,
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    batchSetNotificationsState: build.mutation<
      BatchSetNotificationsStateApiResponse,
      BatchSetNotificationsStateApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/notification_states/batch`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getTimesheetProposals: build.query<
      GetTimesheetProposalsApiResponse,
      GetTimesheetProposalsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals`,
        params: {
          timely_account_id: queryArg.timelyAccountId,
          status: queryArg.status,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          timely_user_id: queryArg.timelyUserId,
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    createTimesheetProposal: build.mutation<
      CreateTimesheetProposalApiResponse,
      CreateTimesheetProposalApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTimesheetProposal: build.query<GetTimesheetProposalApiResponse, GetTimesheetProposalApiArg>({
      query: (queryArg) => ({ url: `/1.0/timesheet-proposals/${queryArg.id}` }),
    }),
    deleteTimesheetProposal: build.mutation<
      DeleteTimesheetProposalApiResponse,
      DeleteTimesheetProposalApiArg
    >({
      query: (queryArg) => ({ url: `/1.0/timesheet-proposals/${queryArg.id}`, method: "DELETE" }),
    }),
    updateTimesheetProposalStatus: build.mutation<
      UpdateTimesheetProposalStatusApiResponse,
      UpdateTimesheetProposalStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals/${queryArg.id}/status`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    createTimesheetProposalEntry: build.mutation<
      CreateTimesheetProposalEntryApiResponse,
      CreateTimesheetProposalEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals/${queryArg.proposalId}/entries`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteTimesheetProposalEntry: build.mutation<
      DeleteTimesheetProposalEntryApiResponse,
      DeleteTimesheetProposalEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals/entries/${queryArg.entryId}`,
        method: "DELETE",
      }),
    }),
    patchTimesheetProposalEntry: build.mutation<
      PatchTimesheetProposalEntryApiResponse,
      PatchTimesheetProposalEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals/entries/${queryArg.entryId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    triggerTimesheetProposalGeneration: build.mutation<
      TriggerTimesheetProposalGenerationApiResponse,
      TriggerTimesheetProposalGenerationApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals/generate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    regenerateEntryNotes: build.mutation<
      RegenerateEntryNotesApiResponse,
      RegenerateEntryNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/timesheet-proposals/regenerate-notes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectSuggestions: build.query<
      GetProjectSuggestionsApiResponse,
      GetProjectSuggestionsApiArg
    >({
      query: (queryArg) => ({ url: `/1.0/accounts/${queryArg.accountId}/project-suggestions` }),
    }),
    triggerProjectSuggestions: build.mutation<
      TriggerProjectSuggestionsApiResponse,
      TriggerProjectSuggestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/project-suggestions/generate`,
        method: "POST",
        body: queryArg.triggerProjectSuggestions,
      }),
    }),
    updateProjectSuggestionStatus: build.mutation<
      UpdateProjectSuggestionStatusApiResponse,
      UpdateProjectSuggestionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/accounts/${queryArg.accountId}/project-suggestions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateProjectSuggestionStatus,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as ticApi };
export type GetMemoryConfigApiResponse = /** status 200 200 */ {
  filters: {
    constructLanesOn?: "time" | "tool" | "category" | "starred";
    /** If lanes are created with less than this value, they will be moved to a general time-based lane. Set to 0 to disable */
    minMinutesForDedicatedLane?: number | null;
    groupMemoriesBy?: "tool" | "title";
    minMinuteGapBetweenMemories?: number;
    /** Memories that are closely related will merge if overlapping */
    pxPerMinute?: number;
    /** Minimum number of pixels per minute. Restricts the minimum zoom level. */
    minPxPerMinute?: number;
    /** Memories will be (at minimum) this long. Useful for memories without a duration. */
    minimumDurationMinutes?: number | null;
    /** Any MemoryGroup with less than this total duration will be hidden */
    minimumGroupDurationMinutes?: number | null;
    /** Allow Memories to expand when a new (similar) Memory is created within this time period. */
    mergeWithinMinutes?: number | null;
    /** Show ignored Memories */
    showIgnored?: boolean | "true" | "false";
    /** Turn off to hide "other memories" lane on Timeline; Summary and dedicated lanes remain */
    showOtherMemoriesLane?: boolean | "true" | "false";
    /** Show all Memories as compacted by default */
    compact?: boolean | "true" | "false";
    namingStrategy?: "auto" | "title" | "tool";
    /** Minutes per summary block; 0 to disable */
    minutesPerBlock?: number | null;
    /** Demo memory settings for generating memories with simulated data */
    demoSettings?: {
      enabled?: boolean;
      preset?: "manager" | "office" | "developer" | "designer" | "seeing_machines";
      calendarTool?: "google_calendar" | "microsoft_outlook_calendar";
      meetingTool?: "google_meet" | "microsoft_teams" | "zoom";
      projectManagementTool?: "clickup" | "monday" | "asana" | "jira" | "linear";
    };
    [key: string]: any;
  };
  /** Indicates whether the user has customized their filters. If false, the default filters are used. */
  customized?: boolean;
};
export type GetMemoryConfigApiArg = void;
export type SaveMemoryConfigApiResponse = /** status 200 200 */ {
  filters: {
    constructLanesOn?: "time" | "tool" | "category" | "starred";
    /** If lanes are created with less than this value, they will be moved to a general time-based lane. Set to 0 to disable */
    minMinutesForDedicatedLane?: number | null;
    groupMemoriesBy?: "tool" | "title";
    minMinuteGapBetweenMemories?: number;
    /** Memories that are closely related will merge if overlapping */
    pxPerMinute?: number;
    /** Minimum number of pixels per minute. Restricts the minimum zoom level. */
    minPxPerMinute?: number;
    /** Memories will be (at minimum) this long. Useful for memories without a duration. */
    minimumDurationMinutes?: number | null;
    /** Any MemoryGroup with less than this total duration will be hidden */
    minimumGroupDurationMinutes?: number | null;
    /** Allow Memories to expand when a new (similar) Memory is created within this time period. */
    mergeWithinMinutes?: number | null;
    /** Show ignored Memories */
    showIgnored?: boolean | "true" | "false";
    /** Turn off to hide "other memories" lane on Timeline; Summary and dedicated lanes remain */
    showOtherMemoriesLane?: boolean | "true" | "false";
    /** Show all Memories as compacted by default */
    compact?: boolean | "true" | "false";
    namingStrategy?: "auto" | "title" | "tool";
    /** Minutes per summary block; 0 to disable */
    minutesPerBlock?: number | null;
    /** Demo memory settings for generating memories with simulated data */
    demoSettings?: {
      enabled?: boolean;
      preset?: "manager" | "office" | "developer" | "designer" | "seeing_machines";
      calendarTool?: "google_calendar" | "microsoft_outlook_calendar";
      meetingTool?: "google_meet" | "microsoft_teams" | "zoom";
      projectManagementTool?: "clickup" | "monday" | "asana" | "jira" | "linear";
    };
    [key: string]: any;
  };
  /** Indicates whether the user has customized their filters. If false, the default filters are used. */
  customized?: boolean;
};
export type SaveMemoryConfigApiArg = {
  /** Body */
  body: {
    constructLanesOn?: "time" | "tool" | "category" | "starred";
    /** If lanes are created with less than this value, they will be moved to a general time-based lane. Set to 0 to disable */
    minMinutesForDedicatedLane?: number | null;
    groupMemoriesBy?: "tool" | "title";
    minMinuteGapBetweenMemories?: number;
    /** Memories that are closely related will merge if overlapping */
    pxPerMinute?: number;
    /** Minimum number of pixels per minute. Restricts the minimum zoom level. */
    minPxPerMinute?: number;
    /** Memories will be (at minimum) this long. Useful for memories without a duration. */
    minimumDurationMinutes?: number | null;
    /** Any MemoryGroup with less than this total duration will be hidden */
    minimumGroupDurationMinutes?: number | null;
    /** Allow Memories to expand when a new (similar) Memory is created within this time period. */
    mergeWithinMinutes?: number | null;
    /** Show ignored Memories */
    showIgnored?: boolean | "true" | "false";
    /** Turn off to hide "other memories" lane on Timeline; Summary and dedicated lanes remain */
    showOtherMemoriesLane?: boolean | "true" | "false";
    /** Show all Memories as compacted by default */
    compact?: boolean | "true" | "false";
    namingStrategy?: "auto" | "title" | "tool";
    /** Minutes per summary block; 0 to disable */
    minutesPerBlock?: number | null;
    /** Demo memory settings for generating memories with simulated data */
    demoSettings?: {
      enabled?: boolean;
      preset?: "manager" | "office" | "developer" | "designer" | "seeing_machines";
      calendarTool?: "google_calendar" | "microsoft_outlook_calendar";
      meetingTool?: "google_meet" | "microsoft_teams" | "zoom";
      projectManagementTool?: "clickup" | "monday" | "asana" | "jira" | "linear";
    };
    [key: string]: any;
  };
};
export type GetMemoriesApiResponse = /** status 200 200 */ {
  memories: {
    /** Memory ID */
    id: number;
    /** CSS-compatible color of this tool */
    color?: string | null;
    /** Memory title */
    title: string;
    /** Verb of this Memory */
    verb?:
      | (
          | "created"
          | "updated"
          | "deleted"
          | "moved"
          | "completed"
          | "copied"
          | "commented"
          | "logged"
        )
      | null;
    /** Memory description */
    description?: string | null;
    /** Best icon to represent this Memory */
    icon_url?: string | null;
    /** Start of this Memory */
    started_at: string;
    /** (Optional) end of this Memory */
    ended_at: string;
    /** Internal record of when this Memory was last touched */
    updated_at: string;
    /** Total seconds of this Memory */
    total_seconds: number;
    /** URL to this Memory */
    url?: string | null;
    tool?: {
      /** Tool ID, if linked */
      id?: string;
      /** Tool name, if linked */
      title?: string;
      /** Tool icon URL */
      icon_url?: string | null;
      /** Raw app/website/program/etc value, if tracked via Memory Recorder */
      raw?: string | null;
    } | null;
    window_tool: {
      /** Tool ID */
      id: string;
      /** Tool title */
      title: string;
      /** Tool icon URL */
      icon_url?: string | null;
      /** Raw tool data */
      raw?: string | null;
    } | null;
    /** Usually references project, workspace, team, etc -- stuff that is not in db, but we may want to group/organize by */
    context?: string | null;
    /** If true, this Memory has been ignored (via a rule, or explicitly marked) */
    ignored?: boolean;
    category?: {
      /** Category ID */
      id:
        | "management"
        | "operations"
        | "finance"
        | "accounting"
        | "hr"
        | "legal"
        | "compliance"
        | "calendar"
        | "timetracking"
        | "spreadsheet"
        | "word_processing"
        | "communication"
        | "news"
        | "social"
        | "video"
        | "video_conferencing"
        | "presentation"
        | "music"
        | "product"
        | "design"
        | "branding"
        | "media_editing"
        | "prototyping"
        | "wireframing"
        | "project_management"
        | "engineering"
        | "developer_tools"
        | "security"
        | "cms"
        | "analytics"
        | "sales"
        | "marketing"
        | "ecommerce"
        | "support"
        | "ticketing"
        | "banking"
        | "gaming"
        | "sport"
        | "ats"
        | "crm"
        | "notes"
        | "invoicing"
        | "knowledge_base"
        | "payment"
        | "productivity"
        | "storage"
        | "surveys"
        | "utilities"
        | "browser"
        | "logistics"
        | "location_tracking";
      /** Category title */
      title: string;
      /** Category icon URL */
      icon_url?: string;
    } | null;
    /** Which Memory App uploaded this Memory? */
    tracker_source: ("mac" | "windows" | "linux" | "browser_extension") | null;
    agent?: {
      external_id?: string;
      provider: string;
      client: string;
      event: "prompt_interaction" | "agent_work";
      session_id?: string;
      session_name?: string;
    } | null;
    /** If true, this Memory comes from the Timely database/format. Only relevant in Timely FE implementation */
    from_timely?: boolean;
    /** Raw API body, if available (see `getMemories`) */
    raw?: {
      [key: string]: any;
    };
    /** Reference to a matching TIC resource, enabling memory-to-project linking */
    ref?: {
      /** Primary URI (task_uri if present, otherwise project_uri) - for backward compatibility */
      uri?: string;
      /** Task-level URI for matching against task resources */
      task_uri?: string;
      /** Project-level URI for matching against project/forecast resources */
      project_uri?: string;
    };
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
  [key: string]: any;
};
export type GetMemoriesApiArg = {
  /** Memories started after this datetime */
  startDate: string;
  /** Memories started before this datetime */
  endDate: string;
  /** Max number of Memories to return */
  limit?: number | null;
  /** Page of Memories to return */
  page?: number | null;
};
export type DeleteMemoriesApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type DeleteMemoriesApiArg = {
  /** Body */
  body: number[];
};
export type GetAiPredictionsInDateRangeApiResponse = /** status 200 200 */ {
  ai_predictions: {
    /** UUID identifier */
    id?: string;
    /** DateTime with timezone */
    started_at: string;
    /** DateTime with timezone */
    ended_at: string;
    inferred: {
      /** Confidence of prediction */
      confidence?: number;
      /** Suggested note to use for time entry */
      note?: string | null;
      /** If true, this prediction has all the required data to create a time entry. */
      valid_as_hour?: boolean;
      /** The Timely `project.id` most likely to apply */
      timely_project_id: number;
      /** Memory IDs that are most likely to apply to this prediction */
      memory_ids?: (string | null)[];
      /** One ID (if only predicting parent tag), or two IDs if predicting to a child label_id */
      timely_label_ids?: number[];
    };
    /** Allows string, but should be one of the enums */
    flagged_as?: ((("rejected" | "note_regenerated") | null) | (string | null)) | null;
  }[];
  meta: {
    count: number;
    totalCount: number;
    dates_updated_at: {
      [key: string]: string | null;
    };
  };
};
export type GetAiPredictionsInDateRangeApiArg = {
  /** DateTime with timezone */
  startedAt: string;
  /** DateTime with timezone */
  endedAt: string;
  /** The Timely `account.id` */
  timelyAccountId: number;
  /** UUID identifier */
  userId?: string;
  /** If true (default), will omit rejected intervals from predictions. If **false**, "negative predictions" are also returned; may be useful for client-side to make optimistic updates easier. */
  applyRejections?: boolean;
};
export type RejectAiPredictionApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type RejectAiPredictionApiArg = {
  /** Body */
  body: {
    /** UUID identifier */
    id: string;
    /** DateTime with timezone */
    started_at: string;
    /** DateTime with timezone */
    ended_at: string;
  };
};
export type GetAiPredictionStatusForDateRangeApiResponse = /** status 200 200 */ {
  status: {
    /** YYYY-MM-DD relative to the users timezone */
    day: string | null;
    updated_at: string;
    /** The type of AI event that occurred */
    event:
      | "inference_complete"
      | "inference_failed"
      | "inference_requested"
      | "inference_pending"
      | "training_requested"
      | "training_pending"
      | "training_running"
      | "training_complete"
      | "training_failed"
      | "training_data_insufficient"
      | "model_reset"
      | "model_health"
      | "training_uninitialized"
      | "inference_uninitialized";
    /** Additional information about the event */
    message?: string | null;
    /** When did this `event` occur? */
    at: string | null;
  }[];
  /** When was the last prediction for each day in the range? */
  dates_updated_at: {
    [key: string]: string;
  };
};
export type GetAiPredictionStatusForDateRangeApiArg = {
  /** YYYY-MM-DD relative to the users timezone */
  fromDate: string;
  /** YYYY-MM-DD relative to the users timezone */
  toDate: string;
  /** The Timely `user.id` */
  timelyUserId: number;
  /** The Timely `account.id` */
  timelyAccountId: number;
};
export type SetAiPredictionStatusApiResponse = /** status 200 200 */ {
  log: {
    /** YYYY-MM-DD relative to the users timezone */
    day: string | null;
    updated_at: string;
    /** The type of AI event that occurred */
    event:
      | "inference_complete"
      | "inference_failed"
      | "inference_requested"
      | "inference_pending"
      | "training_requested"
      | "training_pending"
      | "training_running"
      | "training_complete"
      | "training_failed"
      | "training_data_insufficient"
      | "model_reset"
      | "model_health"
      | "training_uninitialized"
      | "inference_uninitialized";
    /** Additional information about the event */
    message?: string | null;
  };
  message: string;
};
export type SetAiPredictionStatusApiArg = {
  /** Body */
  body: {
    /** The Timely `user.id` */
    timely_user_id: number;
    /** The Timely `account.id` */
    timely_account_id: number;
    /** YYYY-MM-DD relative to the users timezone */
    day: string | null;
    /** The type of AI event that occurred */
    event:
      | "inference_complete"
      | "inference_failed"
      | "inference_requested"
      | "inference_pending"
      | "training_requested"
      | "training_pending"
      | "training_running"
      | "training_complete"
      | "training_failed"
      | "training_data_insufficient"
      | "model_reset"
      | "model_health"
      | "training_uninitialized"
      | "inference_uninitialized";
    /** Additional information about the event */
    message?: string | null;
  };
};
export type RefreshAiPredictionsInDateRangeApiResponse = /** status 200 200 */ {
  log: {
    /** YYYY-MM-DD relative to the users timezone */
    day: string | null;
    updated_at: string;
    /** The type of AI event that occurred */
    event:
      | "inference_complete"
      | "inference_failed"
      | "inference_requested"
      | "inference_pending"
      | "training_requested"
      | "training_pending"
      | "training_running"
      | "training_complete"
      | "training_failed"
      | "training_data_insufficient"
      | "model_reset"
      | "model_health"
      | "training_uninitialized"
      | "inference_uninitialized";
    /** Additional information about the event */
    message?: string | null;
  } | null;
  debug?: {
    [key: string]: any;
  };
};
export type RefreshAiPredictionsInDateRangeApiArg = {
  /** Body */
  body: {
    /** The Timely `account.id` */
    timely_account_id: number;
    /** The Timely `user.id` */
    timely_user_id: number;
    /** YYYY-MM-DD relative to the users Timely specified timezone */
    from_date: string;
    /** YYYY-MM-DD relative to the users Timely specified timezone */
    to_date: string;
    /** Guides AI dedupe logic. Most recent value of either `ai_preferences.updated_at` OR whenever last inference was completed in the supplied `from/to_date` range */
    consequential_change_at?: string;
    /** Project IDs to use for dev-env fake suggestions */
    timely_recent_project_ids?: number[];
  };
};
export type RetrainAiModelApiResponse = /** status 200 200 */ {
  log: {
    /** YYYY-MM-DD relative to the users timezone */
    day: string | null;
    updated_at: string;
    /** The type of AI event that occurred */
    event:
      | "inference_complete"
      | "inference_failed"
      | "inference_requested"
      | "inference_pending"
      | "training_requested"
      | "training_pending"
      | "training_running"
      | "training_complete"
      | "training_failed"
      | "training_data_insufficient"
      | "model_reset"
      | "model_health"
      | "training_uninitialized"
      | "inference_uninitialized";
    /** Additional information about the event */
    message?: string | null;
  } | null;
  debug?: {
    [key: string]: any;
  };
};
export type RetrainAiModelApiArg = {
  /** Body */
  body: {
    timely_account_id: number;
    timely_user_id: number;
  };
};
export type ResetAiModelApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type ResetAiModelApiArg = {
  /** Body */
  body: {
    /** The Timely `account.id` */
    timely_account_id: number;
    /** The Timely `user.id` */
    timely_user_id: number;
    /** AI will only look at time tracking/logging patterns _after_ this date.  */
    model_reset_at?: string;
  };
};
export type RequestHourNoteGenerationApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type RequestHourNoteGenerationApiArg = {
  /** Body */
  body: {
    /** The ID of the timely account. */
    timely_account_id: number;
    /** The start time in UTC. */
    since: string;
    /** The end time in UTC. */
    to: string;
    style: "all" | "without_reference" | "with_reference";
    suggestion?: {
      /** UUID of the suggestion. */
      id?: string | null;
      /** The ID of the project, if available. */
      project_id?: number;
      /** The IDs of the labels, if available. */
      label_ids?: number[];
      /** AI Suggestion. */
      timestamps: {
        /** The start time of the timestamp in UTC. */
        from: string;
        /** The end time of the timestamp in UTC. */
        to: string;
        /** The IDs of memories, can be either tic_group_{id}, tic_{id}, or timely_{id} */
        entry_ids?: (string | null)[];
      }[];
    };
    hour?: {
      /** The ID of the hour, if saved. */
      id?: number;
      /** The ID of the project, if chosen. */
      project_id?: number;
      /** The IDs of the labels, if selected. */
      label_ids?: number[];
      /** Time Entry. */
      timestamps?: {
        /** The start time of the timestamp in UTC. */
        from: string;
        /** The end time of the timestamp in UTC. */
        to: string;
        /** The IDs of memories, can be either tic_group_{id}, tic_{id}, or timely_{id} */
        entry_ids?: (string | null)[];
      }[];
    };
  };
};
export type RequestSuggestionNoteGenerationApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type RequestSuggestionNoteGenerationApiArg = {
  /** Body */
  body: {
    /** The requested style of note to be generated.  */
    style?: "all" | "with_reference" | "without_reference";
    suggestion_ids: string | string[];
    /** The Timely `account.id` */
    timely_account_id: number;
  };
};
export type GetAiPreferencesApiResponse = /** status 200 200 */ {
  id?: string | null;
  /** Is AI enabled for this user? Default true is used to draw initial UI, but AI will NOT activate until user confirms. */
  enabled?: boolean;
  /** Show predictions on the timesheet itself? */
  show_timesheet_predictions?: boolean;
  /** Show predictions on the timeline? */
  show_timeline_predictions?: boolean;
  /** How predictions are presented on the timeline */
  timeline_layout?: "compact" | "wide";
  /** When were these preferences last updated? If null/undefined, it means the user has not set any preferences yet. */
  updated_at?: string | null;
  /** Preset for the AI prediction settings */
  preset?: ("exact" | "efficient" | "concise") | null;
  /** How many minutes of smoothing / filling of gaps should be done? */
  fill_gap?: number;
  /** Minimum duration of a prediction in minutes */
  min_duration?: number;
  /** Should the AI predict tags/labels? Results in higher volume of predictions. */
  train_tags?: boolean;
  /** Should the AI predict notes?  */
  suggest_note?: boolean;
  /** Should the client-side be more relaxed when matching tags to existing time entries? */
  relaxed_tag_matching?: boolean;
  /** Should the client-side be more relaxed when matching notes to existing time entries? */
  relaxed_note_matching?: boolean;
  /** Timesheet assistant specific preferences */
  timesheet_assistant?: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
};
export type GetAiPreferencesApiArg = void;
export type SaveAiPreferencesApiResponse = /** status 200 200 */ {
  id?: string | null;
  /** Is AI enabled for this user? Default true is used to draw initial UI, but AI will NOT activate until user confirms. */
  enabled?: boolean;
  /** Show predictions on the timesheet itself? */
  show_timesheet_predictions?: boolean;
  /** Show predictions on the timeline? */
  show_timeline_predictions?: boolean;
  /** How predictions are presented on the timeline */
  timeline_layout?: "compact" | "wide";
  /** When were these preferences last updated? If null/undefined, it means the user has not set any preferences yet. */
  updated_at?: string | null;
  /** Preset for the AI prediction settings */
  preset?: ("exact" | "efficient" | "concise") | null;
  /** How many minutes of smoothing / filling of gaps should be done? */
  fill_gap?: number;
  /** Minimum duration of a prediction in minutes */
  min_duration?: number;
  /** Should the AI predict tags/labels? Results in higher volume of predictions. */
  train_tags?: boolean;
  /** Should the AI predict notes?  */
  suggest_note?: boolean;
  /** Should the client-side be more relaxed when matching tags to existing time entries? */
  relaxed_tag_matching?: boolean;
  /** Should the client-side be more relaxed when matching notes to existing time entries? */
  relaxed_note_matching?: boolean;
  /** Timesheet assistant specific preferences */
  timesheet_assistant?: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
};
export type SaveAiPreferencesApiArg = {
  /** The Timely `account.id` */
  timelyAccountId: number;
  /** Force re-initialization of AI model */
  sideEffect?: "initialize";
  /** Body */
  body: {
    id?: string | null;
    /** Is AI enabled for this user? Default true is used to draw initial UI, but AI will NOT activate until user confirms. */
    enabled?: boolean;
    /** Show predictions on the timesheet itself? */
    show_timesheet_predictions?: boolean;
    /** Show predictions on the timeline? */
    show_timeline_predictions?: boolean;
    /** How predictions are presented on the timeline */
    timeline_layout?: "compact" | "wide";
    /** When were these preferences last updated? If null/undefined, it means the user has not set any preferences yet. */
    updated_at?: string | null;
    /** Preset for the AI prediction settings */
    preset?: ("exact" | "efficient" | "concise") | null;
    /** How many minutes of smoothing / filling of gaps should be done? */
    fill_gap?: number;
    /** Minimum duration of a prediction in minutes */
    min_duration?: number;
    /** Should the AI predict tags/labels? Results in higher volume of predictions. */
    train_tags?: boolean;
    /** Should the AI predict notes?  */
    suggest_note?: boolean;
    /** Should the client-side be more relaxed when matching tags to existing time entries? */
    relaxed_tag_matching?: boolean;
    /** Should the client-side be more relaxed when matching notes to existing time entries? */
    relaxed_note_matching?: boolean;
    /** Timesheet assistant specific preferences */
    timesheet_assistant?: {
      /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
      interval_minutes?: number;
      /** AI provider to use for timesheet generation */
      provider?: "Anthropic" | "OpenAI";
      /** Effort level for timesheet generation processing */
      effort?: "none" | "low" | "medium";
      /** Language for generated timesheet notes */
      note_language?:
        | "Arabic"
        | "Danish"
        | "Dutch"
        | "English"
        | "French"
        | "German"
        | "Italian"
        | "Japanese"
        | "Norwegian"
        | "Portuguese"
        | "Spanish"
        | "Swedish";
      /** Frequency of daily email summaries */
      daily_generation?: "weekdays_only" | "every_day" | "off";
      /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
      last_reset_at?: string | null;
    };
  };
};
export type GetAiWorkspacePreferencesApiResponse = /** status 200 200 */ {
  timesheet_assistant: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
  /** Fields that are locked/enforced by workspace admin and cannot be changed by users */
  locked_fields?: string[];
};
export type GetAiWorkspacePreferencesApiArg = {
  /** The Timely `account.id` */
  timelyAccountId: number;
};
export type SaveAiWorkspacePreferencesApiResponse = /** status 200 200 */ {
  timesheet_assistant: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
  /** Fields that are locked/enforced by workspace admin and cannot be changed by users */
  locked_fields?: string[];
};
export type SaveAiWorkspacePreferencesApiArg = {
  /** The Timely `account.id` */
  timelyAccountId: number;
  /** Body */
  body: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
};
export type GetAiWorkspaceDefaultsApiResponse = /** status 200 200 */ {
  id?: string | null;
  timely_account_id: number;
  timesheet_assistant?: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
  /** Field names that are enforced for all users in this workspace */
  locked_fields?: string[];
  updated_at?: string | null;
};
export type GetAiWorkspaceDefaultsApiArg = {
  /** The Timely `account.id` */
  timelyAccountId: number;
};
export type SaveAiWorkspaceDefaultsApiResponse = /** status 200 200 */ {
  id?: string | null;
  timely_account_id: number;
  timesheet_assistant?: {
    /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
    interval_minutes?: number;
    /** AI provider to use for timesheet generation */
    provider?: "Anthropic" | "OpenAI";
    /** Effort level for timesheet generation processing */
    effort?: "none" | "low" | "medium";
    /** Language for generated timesheet notes */
    note_language?:
      | "Arabic"
      | "Danish"
      | "Dutch"
      | "English"
      | "French"
      | "German"
      | "Italian"
      | "Japanese"
      | "Norwegian"
      | "Portuguese"
      | "Spanish"
      | "Swedish";
    /** Frequency of daily email summaries */
    daily_generation?: "weekdays_only" | "every_day" | "off";
    /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
    last_reset_at?: string | null;
  };
  /** Field names that are enforced for all users in this workspace */
  locked_fields?: string[];
  updated_at?: string | null;
};
export type SaveAiWorkspaceDefaultsApiArg = {
  /** The Timely `account.id` */
  timelyAccountId: number;
  /** Body */
  body: {
    timesheet_assistant?: {
      /** Interval in minutes for timesheet generation chunking (5 minutes to 24 hours) */
      interval_minutes?: number;
      /** AI provider to use for timesheet generation */
      provider?: "Anthropic" | "OpenAI";
      /** Effort level for timesheet generation processing */
      effort?: "none" | "low" | "medium";
      /** Language for generated timesheet notes */
      note_language?:
        | "Arabic"
        | "Danish"
        | "Dutch"
        | "English"
        | "French"
        | "German"
        | "Italian"
        | "Japanese"
        | "Norwegian"
        | "Portuguese"
        | "Spanish"
        | "Swedish";
      /** Frequency of daily email summaries */
      daily_generation?: "weekdays_only" | "every_day" | "off";
      /** Timestamp of when AI memory was last reset. AI will ignore data before this time. */
      last_reset_at?: string | null;
    };
    locked_fields?: string[];
  };
};
export type GetAssistantResponseApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type GetAssistantResponseApiArg = {
  /** The user message/prompt to send to the AI agent */
  message: string;
  /** The Timely `account.id` */
  timelyAccountId: number;
  /** Session ID to maintain conversation context */
  sessionId?: string;
};
export type ResetEverythingAiApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type ResetEverythingAiApiArg = {
  /** Body */
  body: {
    /** The Timely `account.id` */
    timely_account_id: number;
  };
};
export type GetToolsApiResponse = /** status 200 200 */ {
  tools: {
    /** Tool ID */
    id: string;
    /** Tool title */
    title: string;
    /** Tool icon URL */
    icon_url?: string | null;
    /** Raw tool data */
    raw?: string | null;
    /** Tool description */
    description: string | null;
    /** Tool homepage URL */
    url_homepage: string | null;
    /** Tool support URL */
    url_support: string | null;
    /** Tool aliases */
    aliases: string[];
    /** Tool aliases */
    domains?: string[] | null;
    /** Tool color */
    color: string | null;
    category?: {
      /** Category ID */
      id:
        | "management"
        | "operations"
        | "finance"
        | "accounting"
        | "hr"
        | "legal"
        | "compliance"
        | "calendar"
        | "timetracking"
        | "spreadsheet"
        | "word_processing"
        | "communication"
        | "news"
        | "social"
        | "video"
        | "video_conferencing"
        | "presentation"
        | "music"
        | "product"
        | "design"
        | "branding"
        | "media_editing"
        | "prototyping"
        | "wireframing"
        | "project_management"
        | "engineering"
        | "developer_tools"
        | "security"
        | "cms"
        | "analytics"
        | "sales"
        | "marketing"
        | "ecommerce"
        | "support"
        | "ticketing"
        | "banking"
        | "gaming"
        | "sport"
        | "ats"
        | "crm"
        | "notes"
        | "invoicing"
        | "knowledge_base"
        | "payment"
        | "productivity"
        | "storage"
        | "surveys"
        | "utilities"
        | "browser"
        | "logistics"
        | "location_tracking";
      /** Category title */
      title: string;
      /** Category icon URL */
      icon_url?: string;
    } | null;
    /** Information about the provider (integration) for this tool */
    provider: {
      /** Account provider key */
      account_key: string | null;
      /** Personal provider key */
      personal_key: string | null;
      /** Account operations */
      account_operations: string[];
      /** Personal operations */
      personal_operations: string[];
    } | null;
    /** Information about the connection to this tool, if any */
    connection_info: {
      /** Whether the current user can manage the connection */
      current_user_can_manage: boolean;
      /** Connection ID */
      id: string;
      /** Nango Connection Id. Nullable ONLY if it fails to delete itself (after Nango connection is deleted) */
      nango_connection_id: string | null;
      scope: "personal" | "account" | "all";
      /** When the connection was created */
      created_at: string;
      /** When the connection was disconnected. Nullable if the connection is still active */
      disconnected_at?: string | null;
      /** Last time the connection was active */
      last_active_at: string;
      managing_user: {
        /** User ID */
        id: string;
        /** The TIC `user.name` */
        name: string | null;
        avatar_url?: string | null;
      } | null;
      /** Number of errors from last operations runs */
      error_count: number;
      /** Number of successful operations runs */
      success_count: number;
      account: {
        id: string;
        team_name: string | null;
        personal_account: boolean;
      };
    } | null;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type GetToolsApiArg = {
  /** TIC account ID */
  accountId: string;
  /** Filter by scope */
  scope?: "personal" | "account" | "all";
  /** Only return tools that are connected to the `accountId` */
  onlyConnected?: boolean | "true" | "false";
  /** Only return tools that are providers. */
  onlyProviders?: boolean | "true" | "false";
  /** Return early adopter tools/providers. */
  earlyAdopter?: boolean | "true" | "false";
};
export type GetToolIdApiResponse = /** status 200 200 */ {
  tool: {
    /** Tool ID */
    id: string;
    /** Tool title */
    title: string;
    /** Tool icon URL */
    icon_url?: string | null;
    /** Raw tool data */
    raw?: string | null;
    /** Tool description */
    description: string | null;
    /** Tool homepage URL */
    url_homepage: string | null;
    /** Tool support URL */
    url_support: string | null;
    /** Tool aliases */
    aliases: string[];
    /** Tool aliases */
    domains?: string[] | null;
    /** Tool color */
    color: string | null;
    category?: {
      /** Category ID */
      id:
        | "management"
        | "operations"
        | "finance"
        | "accounting"
        | "hr"
        | "legal"
        | "compliance"
        | "calendar"
        | "timetracking"
        | "spreadsheet"
        | "word_processing"
        | "communication"
        | "news"
        | "social"
        | "video"
        | "video_conferencing"
        | "presentation"
        | "music"
        | "product"
        | "design"
        | "branding"
        | "media_editing"
        | "prototyping"
        | "wireframing"
        | "project_management"
        | "engineering"
        | "developer_tools"
        | "security"
        | "cms"
        | "analytics"
        | "sales"
        | "marketing"
        | "ecommerce"
        | "support"
        | "ticketing"
        | "banking"
        | "gaming"
        | "sport"
        | "ats"
        | "crm"
        | "notes"
        | "invoicing"
        | "knowledge_base"
        | "payment"
        | "productivity"
        | "storage"
        | "surveys"
        | "utilities"
        | "browser"
        | "logistics"
        | "location_tracking";
      /** Category title */
      title: string;
      /** Category icon URL */
      icon_url?: string;
    } | null;
    /** Information about the provider (integration) for this tool */
    provider: {
      /** Account provider key */
      account_key: string | null;
      /** Personal provider key */
      personal_key: string | null;
      /** Account operations */
      account_operations: string[];
      /** Personal operations */
      personal_operations: string[];
    } | null;
    /** Information about the connection to this tool, if any */
    connection_info: {
      /** Whether the current user can manage the connection */
      current_user_can_manage: boolean;
      /** Connection ID */
      id: string;
      /** Nango Connection Id. Nullable ONLY if it fails to delete itself (after Nango connection is deleted) */
      nango_connection_id: string | null;
      scope: "personal" | "account" | "all";
      /** When the connection was created */
      created_at: string;
      /** When the connection was disconnected. Nullable if the connection is still active */
      disconnected_at?: string | null;
      /** Last time the connection was active */
      last_active_at: string;
      managing_user: {
        /** User ID */
        id: string;
        /** The TIC `user.name` */
        name: string | null;
        avatar_url?: string | null;
      } | null;
      /** Number of errors from last operations runs */
      error_count: number;
      /** Number of successful operations runs */
      success_count: number;
      account: {
        id: string;
        team_name: string | null;
        personal_account: boolean;
      };
    } | null;
  };
};
export type GetToolIdApiArg = {
  /** The id of the tool */
  toolId: string;
  /** TIC account ID */
  accountId: string;
};
export type GetToolConfigsApiResponse = /** status 200 200 */ {
  configs: (
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
        /** Config ID */
        id: any;
        /** User ID */
        user_id: string;
        /** When the config was last updated */
        updated_at: string;
      }
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
      }
  )[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type GetToolConfigsApiArg = void;
export type ResetAllToolConfigsApiResponse = /** status 200 200 */ {
  configs: (
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
        /** Config ID */
        id: any;
        /** User ID */
        user_id: string;
        /** When the config was last updated */
        updated_at: string;
      }
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
      }
  )[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type ResetAllToolConfigsApiArg = void;
export type GetDefaultToolConfigsApiResponse = /** status 200 200 */ {
  configs: (
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
        /** Config ID */
        id: any;
        /** User ID */
        user_id: string;
        /** When the config was last updated */
        updated_at: string;
      }
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
      }
  )[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type GetDefaultToolConfigsApiArg = void;
export type SaveToolConfigApiResponse = /** status 200 200 */
  | {
      /** Tool ID */
      tool_id?: string | null;
      /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
      tool_raw?: string | null;
      preferences: {
        group_by?: "default" | "tool" | "title";
        /** Mute Memories from this tool */
        ignored?: boolean;
        continuity?: "default" | "off" | "low" | "medium" | "high";
        noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
        naming_strategy?: "default" | "title" | "tool" | "hide";
        /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
        sticky?: boolean;
        /** Show Memories from this tool in a dedicated lane */
        dedicated_lane?: boolean;
        /** Show Memories from this tool without the title */
        compact?: boolean | "true" | "false";
        /** Mark memories from this tool as important (starred) */
        starred?: boolean;
      };
      tool?: {
        /** Tool ID */
        id: string;
        /** Tool title */
        title: string;
        /** Tool icon URL */
        icon_url?: string | null;
        /** Raw tool data */
        raw?: string | null;
      } | null;
      /** Config ID */
      id: any;
      /** User ID */
      user_id: string;
      /** When the config was last updated */
      updated_at: string;
    }
  | /** status 204 204 */ (string | null);
export type SaveToolConfigApiArg = {
  /** Tool ID */
  toolId?: string | null;
  /** If we don't have a `tool.id` (e.g non-configured tool), tool_raw works as identifier */
  toolRaw?: string | null;
  /** Body */
  body: {
    /** Tool ID */
    tool_id?: string | null;
    /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
    tool_raw?: string | null;
    preferences: {
      group_by?: "default" | "tool" | "title";
      /** Mute Memories from this tool */
      ignored?: boolean;
      continuity?: "default" | "off" | "low" | "medium" | "high";
      noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
      naming_strategy?: "default" | "title" | "tool" | "hide";
      /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
      sticky?: boolean;
      /** Show Memories from this tool in a dedicated lane */
      dedicated_lane?: boolean;
      /** Show Memories from this tool without the title */
      compact?: boolean | "true" | "false";
      /** Mark memories from this tool as important (starred) */
      starred?: boolean;
    };
    tool?: {
      /** Tool ID */
      id: string;
      /** Tool title */
      title: string;
      /** Tool icon URL */
      icon_url?: string | null;
      /** Raw tool data */
      raw?: string | null;
    } | null;
  };
};
export type DeleteToolConfigApiResponse = /** status 200 200 */ {
  config?:
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
        /** Config ID */
        id: any;
        /** User ID */
        user_id: string;
        /** When the config was last updated */
        updated_at: string;
      }
    | {
        /** Tool ID */
        tool_id?: string | null;
        /** Tools that haven't been defined by us, won't have a tool_id, so we use the raw identifier to store configurations */
        tool_raw?: string | null;
        preferences: {
          group_by?: "default" | "tool" | "title";
          /** Mute Memories from this tool */
          ignored?: boolean;
          continuity?: "default" | "off" | "low" | "medium" | "high";
          noise_cancellation?: "default" | "off" | "low" | "medium" | "high";
          naming_strategy?: "default" | "title" | "tool" | "hide";
          /** Sticky Memories from tool in a dedicated lane (forces `dedicated_lane` on) */
          sticky?: boolean;
          /** Show Memories from this tool in a dedicated lane */
          dedicated_lane?: boolean;
          /** Show Memories from this tool without the title */
          compact?: boolean | "true" | "false";
          /** Mark memories from this tool as important (starred) */
          starred?: boolean;
        };
        tool?: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        } | null;
      };
  meta: {
    /** Indicates the `data` returned is a default/pre-defined config */
    is_predefined_config?: boolean;
  };
};
export type DeleteToolConfigApiArg = {
  /** Tool ID */
  toolId?: string | null;
  /** If we don't have a `tool.id` (e.g non-configured tool), tool_raw works as identifier */
  toolRaw?: string | null;
};
export type UpdateBatchOfSubscriptionsApiResponse = /** status 200 200 */
  | {
      message: string;
      status?: string;
      operationsLog: {
        message: string;
        status?: string;
        /** Unique ID for tracking operation execution */
        job_id?: string;
        errors?: string[];
        jobSummary: {
          executionSeconds: string;
          executedOperations?: string[];
          okCount: number;
          errorCount: number;
          xhrLog?: {
            [key: string]: any;
          }[];
          connectionDetails?: {
            [key: string]: any;
          };
          storedDataCount?: number;
          [key: string]: any;
        };
        operationIdJobRuns?: {
          operationId:
            | (
                | "importClients"
                | "importClient"
                | "importProjects"
                | "importProject"
                | "importProjectPermissions"
                | "importTasks"
                | "importTask"
                | "importLabels"
                | "importTeams"
                | "importTeam"
                | "importOrganizations"
                | "importOrganization"
                | "importIdentities"
                | "importIdentity"
                | "importPullRequests"
                | "importPullRequest"
                | "importMemories"
                | "syncWebhookDefinitions"
                | "syncWebhooks"
                | "handleIncomingWebhook"
                | "getCustomSettingsFields"
              )
            | (
                | "importIdentityStorage"
                | "importIdentitiesStorage"
                | "syncWebhookDefinitionsStorage"
                | "syncWebhooksStorage"
                | "upsertResourcesAndAssociations"
                | "upsertMemoriesAndAssociations"
                | "importMemoriesStorage"
              )
            | ("initialize" | "synchronize")
            | "getConnectionDetails"
            | "initAuthSession"
            | "forceFullImport"
            | "reset"
            | ("DataDiffCreated" | "DataDiffProcessed");
          status?: "ok" | "error";
          error?: string;
          errorName?: string;
          errorCode?: string;
          errorCauseCode?: string;
          data?:
            | {
                [key: string]: any;
              }[]
            | {
                [key: string]: any;
              };
          [key: string]: any;
        }[];
        [key: string]: any;
      } | null;
      /** Indicates if operation runs in background */
      async?: boolean;
      /** Unique ID for tracking operation execution */
      job_id?: string;
      /** Unique ID for tracking background operation */
      operation_execution_id?: string;
      /** Background job identifier when executionMode=worker */
      trigger_run_id?: string;
      [key: string]: any;
    }
  | {
      code?: number;
      message: string;
      [key: string]: any;
    };
export type UpdateBatchOfSubscriptionsApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** TIC account ID */
  accountId: string;
  /** Connection ID */
  connectionId: string;
  /** Body */
  body: {
    runOperationId?: "synchronize";
    subscriptions: {
      subscription_id: string;
      resource_id: string;
      enabled: boolean;
    }[];
  };
};
export type GetSubscribableResourcesApiResponse = /** status 200 200 */ {
  subscriptions: {
    resource_id: string;
    connection_id?: string;
    synced_at: string | null;
    enabled: boolean;
    subscription_id: string;
    title: string;
    is_root?: boolean;
    icon_url?: string | null;
    webhook_supported: boolean;
    webhook_enabled: boolean;
    webhook_active: boolean;
    external_type?: string;
    /** Profile-aware resource type (e.g., board_as_client maps Trello boards to client). Optional for legacy providers. */
    resource_type?:
      | "organization"
      | "team"
      | "client"
      | "project"
      | "task"
      | "tag"
      | "pull_request";
    user_can_modify?: boolean;
    subscription_type: ("auto" | "manual") | null;
    sub_subscriptions_enabled_count?: number | null;
    sub_subscriptions_total_count?: number | null;
    sub_subscriptions:
      | {
          resource_id: string;
          connection_id?: string;
          synced_at: string | null;
          enabled: boolean;
          subscription_id: string;
          title: string;
          is_root?: boolean;
          icon_url?: string | null;
          webhook_supported: boolean;
          webhook_enabled: boolean;
          webhook_active: boolean;
          external_type?: string;
          /** Profile-aware resource type (e.g., board_as_client maps Trello boards to client). Optional for legacy providers. */
          resource_type?:
            | "organization"
            | "team"
            | "client"
            | "project"
            | "task"
            | "tag"
            | "pull_request";
          user_can_modify?: boolean;
          subscription_type: ("auto" | "manual") | null;
        }[]
      | null;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
  };
};
export type GetSubscribableResourcesApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** TIC account ID */
  accountId: string;
  /** Connection ID */
  connectionId: string;
};
export type ProviderOperationIdApiResponse = /** status 200 200 */ {
  message: string;
  status?: string;
  operationsLog: {
    message: string;
    status?: string;
    /** Unique ID for tracking operation execution */
    job_id?: string;
    errors?: string[];
    jobSummary: {
      executionSeconds: string;
      executedOperations?: string[];
      okCount: number;
      errorCount: number;
      xhrLog?: {
        [key: string]: any;
      }[];
      connectionDetails?: {
        [key: string]: any;
      };
      storedDataCount?: number;
      [key: string]: any;
    };
    operationIdJobRuns?: {
      operationId:
        | (
            | "importClients"
            | "importClient"
            | "importProjects"
            | "importProject"
            | "importProjectPermissions"
            | "importTasks"
            | "importTask"
            | "importLabels"
            | "importTeams"
            | "importTeam"
            | "importOrganizations"
            | "importOrganization"
            | "importIdentities"
            | "importIdentity"
            | "importPullRequests"
            | "importPullRequest"
            | "importMemories"
            | "syncWebhookDefinitions"
            | "syncWebhooks"
            | "handleIncomingWebhook"
            | "getCustomSettingsFields"
          )
        | (
            | "importIdentityStorage"
            | "importIdentitiesStorage"
            | "syncWebhookDefinitionsStorage"
            | "syncWebhooksStorage"
            | "upsertResourcesAndAssociations"
            | "upsertMemoriesAndAssociations"
            | "importMemoriesStorage"
          )
        | ("initialize" | "synchronize")
        | "getConnectionDetails"
        | "initAuthSession"
        | "forceFullImport"
        | "reset"
        | ("DataDiffCreated" | "DataDiffProcessed");
      status?: "ok" | "error";
      error?: string;
      errorName?: string;
      errorCode?: string;
      errorCauseCode?: string;
      data?:
        | {
            [key: string]: any;
          }[]
        | {
            [key: string]: any;
          };
      [key: string]: any;
    }[];
    [key: string]: any;
  } | null;
  /** Indicates if operation runs in background */
  async?: boolean;
  /** Unique ID for tracking operation execution */
  job_id?: string;
  /** Unique ID for tracking background operation */
  operation_execution_id?: string;
  /** Background job identifier when executionMode=worker */
  trigger_run_id?: string;
  [key: string]: any;
};
export type ProviderOperationIdApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Operation to execute */
  operationId:
    | (
        | "importClients"
        | "importClient"
        | "importProjects"
        | "importProject"
        | "importProjectPermissions"
        | "importTasks"
        | "importTask"
        | "importLabels"
        | "importTeams"
        | "importTeam"
        | "importOrganizations"
        | "importOrganization"
        | "importIdentities"
        | "importIdentity"
        | "importPullRequests"
        | "importPullRequest"
        | "importMemories"
        | "syncWebhookDefinitions"
        | "syncWebhooks"
        | "handleIncomingWebhook"
        | "getCustomSettingsFields"
      )
    | ("initialize" | "synchronize");
  /** Connection ID */
  connectionId: string;
  /** Finds the the `connection` via Nango reference */
  nangoConnectionId?: string;
  /** The primary Timely workspace account ID for proper Pusher event routing (required for individual connections) */
  currentTimelyAccountId?: number;
  /** Execution mode override; worker enqueues a pgboss background job */
  executionMode?: "serverless" | "worker";
  /** When true, clear TIC-side connection and subscription metadata before synchronize so the provider reimports from a clean import cursor without deleting stored resources */
  forceFullImport?: boolean;
  /** When true, after a successful synchronize run, finalize integration setup (idempotent) and enqueue the initial full Timely diff generation */
  generateDiffAfterSync?: boolean;
  /** Optional operation param passthrough (e.g. /task/<id>) */
  urlOrPath?: string;
};
export type GetIntegrationsApiResponse = /** status 200 200 */ {
  data: {
    /** Provider ID (same as tool.id) */
    id:
      | "asana"
      | "clickup"
      | "github"
      | "jira"
      | "linear"
      | "monday"
      | "salesforce"
      | "salesforce-sandbox"
      | "trello"
      | "base";
    /** Integration display name */
    title: string;
    /** Integration description */
    description: string | null;
    /** Integration icon URL */
    icon_url: string | null;
    /** Integration brand color */
    color: string | null;
    /** Whether this integration is experimental */
    experimental: boolean;
    /** Personal scope data, null if not supported */
    personal: {
      /** Whether this scope is supported by the integration */
      supported: boolean;
      /** Connection information, null if no connection exists */
      connection: {
        /** Connection ID */
        id: string;
        /** TIC account ID */
        account_id: string;
        /** Nango connection reference ID */
        nango_connection_id: string | null;
        /** DateTime with timezone */
        created_at: string;
        /** DateTime with timezone */
        updated_at: string;
        settings: {
          /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
          version?: number | null;
          /** Should new data be auto-subscribed? */
          auto_subscribe?: boolean | null;
          /** How much of the imported data should be stored? Set to minimum for only the essentials. */
          import_data_detail_level?: "default" | "minimum";
          /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
          import_profile_key?: string;
          /** Whether setup wizard is complete and data diff dumping to Timely should be active */
          setup_completed?: boolean | null;
          /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
          setup_settings_configured?: boolean;
          /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
          sync_to_timely?: ("on_demand" | "continuous") | null;
          /** Should projects sync to Timely? */
          sync_projects?: boolean | null;
          /** Should tasks be synced to Timely? */
          sync_tasks?: boolean | null;
          /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
          reference_tasks?: boolean | null;
          /** Should labels be synced to Timely? */
          sync_tags?: boolean | null;
          /** Should clients sync to Timely? */
          sync_clients?: boolean | null;
          /** Should teams sync to Timely? */
          sync_teams?: boolean | null;
          /** Should users sync to Timely? */
          sync_users?: boolean | null;
          /** Should memories be created in TIC? */
          sync_memories?: boolean | null;
          /** Default client ID to assign to imported projects when no client mapping is available */
          fallback_timely_client_id?: number | null;
          /** Provider custom fields that should produce or resolve TIC resource relationships */
          custom_field_mappings?:
            | {
                /** Provider-scoped mapping identifier */
                id: string;
                /** Provider custom field identifier */
                field_id: string;
                /** The TIC resource type produced from this provider custom field */
                target_resource_type: "client";
                /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                context?: {
                  [key: string]: string | number | boolean;
                };
              }[]
            | null;
          /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
          sync_time_entries?: boolean | null;
          /** Add all workspace users to imported projects */
          project_add_all_workspace_users?: boolean;
          /** Replace vs merge project users on update */
          project_replace_users_on_update?: boolean;
          /** Send invites when adding users to projects */
          project_send_invites?: boolean;
          /** Set required_labels flag on imported projects */
          project_require_labels?: boolean;
          /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
          project_auto_add_assignees_to_projects?: boolean;
          /** Default billing rate type for new projects */
          project_default_rate_type?: "project" | "user" | "non-billable";
          /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
          restrict_tasks_to_assignees?: boolean | null;
        };
        /** Who can access imported data */
        imported_data_access?: "default" | "everyone";
        /** When connection was disconnected */
        disconnected_at?: string | null;
        /** Reason for disconnection */
        disconnection_reason:
          | (
              | "authentication_failed"
              | "nango_refresh_exhausted"
              | "nango_connection_deleted"
              | "missing_identity_claim"
            )
          | null;
        connected: boolean;
        current_user_can_manage: boolean;
        managing_user: {
          /** User ID */
          id: string;
          /** The TIC `user.name` */
          name: string | null;
          avatar_url?: string | null;
        } | null;
      } | null;
      /** Whether all synchronize operations have been run successfully */
      has_synchronized?: boolean;
    } | null;
    /** Account scope data, null if not supported */
    account: {
      /** Whether this scope is supported by the integration */
      supported: boolean;
      /** Connection information, null if no connection exists */
      connection: {
        /** Connection ID */
        id: string;
        /** TIC account ID */
        account_id: string;
        /** Nango connection reference ID */
        nango_connection_id: string | null;
        /** DateTime with timezone */
        created_at: string;
        /** DateTime with timezone */
        updated_at: string;
        settings: {
          /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
          version?: number | null;
          /** Should new data be auto-subscribed? */
          auto_subscribe?: boolean | null;
          /** How much of the imported data should be stored? Set to minimum for only the essentials. */
          import_data_detail_level?: "default" | "minimum";
          /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
          import_profile_key?: string;
          /** Whether setup wizard is complete and data diff dumping to Timely should be active */
          setup_completed?: boolean | null;
          /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
          setup_settings_configured?: boolean;
          /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
          sync_to_timely?: ("on_demand" | "continuous") | null;
          /** Should projects sync to Timely? */
          sync_projects?: boolean | null;
          /** Should tasks be synced to Timely? */
          sync_tasks?: boolean | null;
          /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
          reference_tasks?: boolean | null;
          /** Should labels be synced to Timely? */
          sync_tags?: boolean | null;
          /** Should clients sync to Timely? */
          sync_clients?: boolean | null;
          /** Should teams sync to Timely? */
          sync_teams?: boolean | null;
          /** Should users sync to Timely? */
          sync_users?: boolean | null;
          /** Should memories be created in TIC? */
          sync_memories?: boolean | null;
          /** Default client ID to assign to imported projects when no client mapping is available */
          fallback_timely_client_id?: number | null;
          /** Provider custom fields that should produce or resolve TIC resource relationships */
          custom_field_mappings?:
            | {
                /** Provider-scoped mapping identifier */
                id: string;
                /** Provider custom field identifier */
                field_id: string;
                /** The TIC resource type produced from this provider custom field */
                target_resource_type: "client";
                /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                context?: {
                  [key: string]: string | number | boolean;
                };
              }[]
            | null;
          /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
          sync_time_entries?: boolean | null;
          /** Add all workspace users to imported projects */
          project_add_all_workspace_users?: boolean;
          /** Replace vs merge project users on update */
          project_replace_users_on_update?: boolean;
          /** Send invites when adding users to projects */
          project_send_invites?: boolean;
          /** Set required_labels flag on imported projects */
          project_require_labels?: boolean;
          /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
          project_auto_add_assignees_to_projects?: boolean;
          /** Default billing rate type for new projects */
          project_default_rate_type?: "project" | "user" | "non-billable";
          /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
          restrict_tasks_to_assignees?: boolean | null;
        };
        /** Who can access imported data */
        imported_data_access?: "default" | "everyone";
        /** When connection was disconnected */
        disconnected_at?: string | null;
        /** Reason for disconnection */
        disconnection_reason:
          | (
              | "authentication_failed"
              | "nango_refresh_exhausted"
              | "nango_connection_deleted"
              | "missing_identity_claim"
            )
          | null;
        connected: boolean;
        current_user_can_manage: boolean;
        managing_user: {
          /** User ID */
          id: string;
          /** The TIC `user.name` */
          name: string | null;
          avatar_url?: string | null;
        } | null;
      } | null;
      /** Whether all synchronize operations have been run successfully */
      has_synchronized?: boolean;
    } | null;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type GetIntegrationsApiArg = {
  /** Account ID to get integrations for */
  accountId: string;
};
export type GetIntegrationDetailsApiResponse = /** status 200 200 */ {
  /** Complete integration details with configuration and setup data */
  data: {
    /** Provider ID (same as tool.id) */
    id:
      | "asana"
      | "clickup"
      | "github"
      | "jira"
      | "linear"
      | "monday"
      | "salesforce"
      | "salesforce-sandbox"
      | "trello"
      | "base";
    /** Integration display name */
    title: string;
    /** Integration description */
    description: string | null;
    /** Integration icon URL */
    icon_url: string | null;
    /** Integration brand color */
    color: string | null;
    /** Whether this integration is experimental */
    experimental: boolean;
    /** Personal scope data with operations, null if not supported */
    personal: {
      /** Whether this scope is supported by the integration */
      supported: boolean;
      /** Connection information, null if no connection exists */
      connection: {
        /** Connection ID */
        id: string;
        /** TIC account ID */
        account_id: string;
        /** Nango connection reference ID */
        nango_connection_id: string | null;
        /** DateTime with timezone */
        created_at: string;
        /** DateTime with timezone */
        updated_at: string;
        settings: {
          /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
          version?: number | null;
          /** Should new data be auto-subscribed? */
          auto_subscribe?: boolean | null;
          /** How much of the imported data should be stored? Set to minimum for only the essentials. */
          import_data_detail_level?: "default" | "minimum";
          /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
          import_profile_key?: string;
          /** Whether setup wizard is complete and data diff dumping to Timely should be active */
          setup_completed?: boolean | null;
          /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
          setup_settings_configured?: boolean;
          /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
          sync_to_timely?: ("on_demand" | "continuous") | null;
          /** Should projects sync to Timely? */
          sync_projects?: boolean | null;
          /** Should tasks be synced to Timely? */
          sync_tasks?: boolean | null;
          /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
          reference_tasks?: boolean | null;
          /** Should labels be synced to Timely? */
          sync_tags?: boolean | null;
          /** Should clients sync to Timely? */
          sync_clients?: boolean | null;
          /** Should teams sync to Timely? */
          sync_teams?: boolean | null;
          /** Should users sync to Timely? */
          sync_users?: boolean | null;
          /** Should memories be created in TIC? */
          sync_memories?: boolean | null;
          /** Default client ID to assign to imported projects when no client mapping is available */
          fallback_timely_client_id?: number | null;
          /** Provider custom fields that should produce or resolve TIC resource relationships */
          custom_field_mappings?:
            | {
                /** Provider-scoped mapping identifier */
                id: string;
                /** Provider custom field identifier */
                field_id: string;
                /** The TIC resource type produced from this provider custom field */
                target_resource_type: "client";
                /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                context?: {
                  [key: string]: string | number | boolean;
                };
              }[]
            | null;
          /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
          sync_time_entries?: boolean | null;
          /** Add all workspace users to imported projects */
          project_add_all_workspace_users?: boolean;
          /** Replace vs merge project users on update */
          project_replace_users_on_update?: boolean;
          /** Send invites when adding users to projects */
          project_send_invites?: boolean;
          /** Set required_labels flag on imported projects */
          project_require_labels?: boolean;
          /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
          project_auto_add_assignees_to_projects?: boolean;
          /** Default billing rate type for new projects */
          project_default_rate_type?: "project" | "user" | "non-billable";
          /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
          restrict_tasks_to_assignees?: boolean | null;
        };
        /** Who can access imported data */
        imported_data_access?: "default" | "everyone";
        /** When connection was disconnected */
        disconnected_at?: string | null;
        /** Reason for disconnection */
        disconnection_reason:
          | (
              | "authentication_failed"
              | "nango_refresh_exhausted"
              | "nango_connection_deleted"
              | "missing_identity_claim"
            )
          | null;
        connected: boolean;
        current_user_can_manage: boolean;
        managing_user: {
          /** User ID */
          id: string;
          /** The TIC `user.name` */
          name: string | null;
          avatar_url?: string | null;
        } | null;
      } | null;
      /** Whether all synchronize operations have been run successfully */
      has_synchronized: boolean;
      /** Whether all initialize operations have been run successfully */
      has_initialized: boolean;
      /** Available operations with execution history */
      operations: {
        operationId:
          | (
              | "importClients"
              | "importClient"
              | "importProjects"
              | "importProject"
              | "importProjectPermissions"
              | "importTasks"
              | "importTask"
              | "importLabels"
              | "importTeams"
              | "importTeam"
              | "importOrganizations"
              | "importOrganization"
              | "importIdentities"
              | "importIdentity"
              | "importPullRequests"
              | "importPullRequest"
              | "importMemories"
              | "syncWebhookDefinitions"
              | "syncWebhooks"
              | "handleIncomingWebhook"
              | "getCustomSettingsFields"
            )
          | ("initialize" | "synchronize");
        title?: string;
        /** Optional mapping of profile key to operation title override. */
        titleByProfile?: {
          [key: string]: string;
        };
        /** The scope of the integration */
        provider_scope?: "personal" | "account" | "all";
        run_on_initialize?: boolean;
        run_on_synchronize?: boolean;
        enabled?: boolean;
        supported?: boolean;
        settings?:
          | {
              key:
                | (
                    | "sync_projects"
                    | "sync_tasks"
                    | "reference_tasks"
                    | "sync_tags"
                    | "sync_clients"
                    | "sync_teams"
                    | "sync_users"
                    | "sync_memories"
                    | "sync_time_entries"
                  )
                | (
                    | "project_add_all_workspace_users"
                    | "project_replace_users_on_update"
                    | "project_send_invites"
                    | "project_require_labels"
                    | "project_auto_add_assignees_to_projects"
                  );
              label?: string;
              source?: string;
              tooltip?: string;
              dependant_on?: (
                | "sync_projects"
                | "sync_tasks"
                | "reference_tasks"
                | "sync_tags"
                | "sync_clients"
                | "sync_teams"
                | "sync_users"
                | "sync_memories"
                | "sync_time_entries"
              )[];
              defaultValue?: boolean;
              /** When false, setting is enforced but hidden from UI. */
              visibleToEndUser?: boolean | null;
              /** When true, setting is only visible to Timely employees. */
              internalOnly?: boolean | null;
            }[]
          | null;
        last_run: {
          when?: string;
          error?: ((string | null) | (boolean | null)) | null;
          executionSeconds?: number | null;
        } | null;
      }[];
      /** Provider configuration key for Nango connection (provider-scope) */
      provider_config_key: string;
      /** OAuth scopes required for this scope */
      oauth_scopes: {
        /** OAuth scope identifier */
        key: string;
        /** Human-readable description of the permission */
        description: string;
      }[];
      /** Whether webhooks are supported for this scope */
      supports_webhooks: boolean;
    } | null;
    /** Account scope data with operations, null if not supported */
    account: {
      /** Whether this scope is supported by the integration */
      supported: boolean;
      /** Connection information, null if no connection exists */
      connection: {
        /** Connection ID */
        id: string;
        /** TIC account ID */
        account_id: string;
        /** Nango connection reference ID */
        nango_connection_id: string | null;
        /** DateTime with timezone */
        created_at: string;
        /** DateTime with timezone */
        updated_at: string;
        settings: {
          /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
          version?: number | null;
          /** Should new data be auto-subscribed? */
          auto_subscribe?: boolean | null;
          /** How much of the imported data should be stored? Set to minimum for only the essentials. */
          import_data_detail_level?: "default" | "minimum";
          /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
          import_profile_key?: string;
          /** Whether setup wizard is complete and data diff dumping to Timely should be active */
          setup_completed?: boolean | null;
          /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
          setup_settings_configured?: boolean;
          /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
          sync_to_timely?: ("on_demand" | "continuous") | null;
          /** Should projects sync to Timely? */
          sync_projects?: boolean | null;
          /** Should tasks be synced to Timely? */
          sync_tasks?: boolean | null;
          /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
          reference_tasks?: boolean | null;
          /** Should labels be synced to Timely? */
          sync_tags?: boolean | null;
          /** Should clients sync to Timely? */
          sync_clients?: boolean | null;
          /** Should teams sync to Timely? */
          sync_teams?: boolean | null;
          /** Should users sync to Timely? */
          sync_users?: boolean | null;
          /** Should memories be created in TIC? */
          sync_memories?: boolean | null;
          /** Default client ID to assign to imported projects when no client mapping is available */
          fallback_timely_client_id?: number | null;
          /** Provider custom fields that should produce or resolve TIC resource relationships */
          custom_field_mappings?:
            | {
                /** Provider-scoped mapping identifier */
                id: string;
                /** Provider custom field identifier */
                field_id: string;
                /** The TIC resource type produced from this provider custom field */
                target_resource_type: "client";
                /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                context?: {
                  [key: string]: string | number | boolean;
                };
              }[]
            | null;
          /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
          sync_time_entries?: boolean | null;
          /** Add all workspace users to imported projects */
          project_add_all_workspace_users?: boolean;
          /** Replace vs merge project users on update */
          project_replace_users_on_update?: boolean;
          /** Send invites when adding users to projects */
          project_send_invites?: boolean;
          /** Set required_labels flag on imported projects */
          project_require_labels?: boolean;
          /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
          project_auto_add_assignees_to_projects?: boolean;
          /** Default billing rate type for new projects */
          project_default_rate_type?: "project" | "user" | "non-billable";
          /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
          restrict_tasks_to_assignees?: boolean | null;
        };
        /** Who can access imported data */
        imported_data_access?: "default" | "everyone";
        /** When connection was disconnected */
        disconnected_at?: string | null;
        /** Reason for disconnection */
        disconnection_reason:
          | (
              | "authentication_failed"
              | "nango_refresh_exhausted"
              | "nango_connection_deleted"
              | "missing_identity_claim"
            )
          | null;
        connected: boolean;
        current_user_can_manage: boolean;
        managing_user: {
          /** User ID */
          id: string;
          /** The TIC `user.name` */
          name: string | null;
          avatar_url?: string | null;
        } | null;
      } | null;
      /** Whether all synchronize operations have been run successfully */
      has_synchronized: boolean;
      /** Whether all initialize operations have been run successfully */
      has_initialized: boolean;
      /** Available operations with execution history */
      operations: {
        operationId:
          | (
              | "importClients"
              | "importClient"
              | "importProjects"
              | "importProject"
              | "importProjectPermissions"
              | "importTasks"
              | "importTask"
              | "importLabels"
              | "importTeams"
              | "importTeam"
              | "importOrganizations"
              | "importOrganization"
              | "importIdentities"
              | "importIdentity"
              | "importPullRequests"
              | "importPullRequest"
              | "importMemories"
              | "syncWebhookDefinitions"
              | "syncWebhooks"
              | "handleIncomingWebhook"
              | "getCustomSettingsFields"
            )
          | ("initialize" | "synchronize");
        title?: string;
        /** Optional mapping of profile key to operation title override. */
        titleByProfile?: {
          [key: string]: string;
        };
        /** The scope of the integration */
        provider_scope?: "personal" | "account" | "all";
        run_on_initialize?: boolean;
        run_on_synchronize?: boolean;
        enabled?: boolean;
        supported?: boolean;
        settings?:
          | {
              key:
                | (
                    | "sync_projects"
                    | "sync_tasks"
                    | "reference_tasks"
                    | "sync_tags"
                    | "sync_clients"
                    | "sync_teams"
                    | "sync_users"
                    | "sync_memories"
                    | "sync_time_entries"
                  )
                | (
                    | "project_add_all_workspace_users"
                    | "project_replace_users_on_update"
                    | "project_send_invites"
                    | "project_require_labels"
                    | "project_auto_add_assignees_to_projects"
                  );
              label?: string;
              source?: string;
              tooltip?: string;
              dependant_on?: (
                | "sync_projects"
                | "sync_tasks"
                | "reference_tasks"
                | "sync_tags"
                | "sync_clients"
                | "sync_teams"
                | "sync_users"
                | "sync_memories"
                | "sync_time_entries"
              )[];
              defaultValue?: boolean;
              /** When false, setting is enforced but hidden from UI. */
              visibleToEndUser?: boolean | null;
              /** When true, setting is only visible to Timely employees. */
              internalOnly?: boolean | null;
            }[]
          | null;
        last_run: {
          when?: string;
          error?: ((string | null) | (boolean | null)) | null;
          executionSeconds?: number | null;
        } | null;
      }[];
      /** Provider configuration key for Nango connection (provider-scope) */
      provider_config_key: string;
      /** OAuth scopes required for this scope */
      oauth_scopes: {
        /** OAuth scope identifier */
        key: string;
        /** Human-readable description of the permission */
        description: string;
      }[];
      /** Whether webhooks are supported for this scope */
      supports_webhooks: boolean;
    } | null;
    /** Account-scoped sync settings declared by the provider */
    sync_settings: {
      key:
        | (
            | "sync_projects"
            | "sync_tasks"
            | "reference_tasks"
            | "sync_tags"
            | "sync_clients"
            | "sync_teams"
            | "sync_users"
            | "sync_memories"
            | "sync_time_entries"
          )
        | (
            | "project_add_all_workspace_users"
            | "project_replace_users_on_update"
            | "project_send_invites"
            | "project_require_labels"
            | "project_auto_add_assignees_to_projects"
          );
      label?: string;
      source?: string;
      tooltip?: string;
      dependant_on?: (
        | "sync_projects"
        | "sync_tasks"
        | "reference_tasks"
        | "sync_tags"
        | "sync_clients"
        | "sync_teams"
        | "sync_users"
        | "sync_memories"
        | "sync_time_entries"
      )[];
      defaultValue?: boolean;
      /** When false, setting is enforced but hidden from UI. */
      visibleToEndUser?: boolean | null;
      /** When true, setting is only visible to Timely employees. */
      internalOnly?: boolean | null;
    }[];
    /** Whether the provider runs on the fan-out sync framework (sync progress comes from sync_run) rather than the legacy per-operation pipeline */
    framework?: boolean;
    /** Whether this provider has a single root resource */
    single_root_resource: boolean;
    /** Homepage URL for the provider */
    url_homepage?: string;
    /** Support URL for the provider */
    url_support?: string;
    /** Form fields required for provider setup */
    form_fields: {
      /** Human-readable field label shown in provider-generated UI */
      label: string;
      /** Stable provider field identifier in the active form context */
      fieldName: string;
      /** Connection settings array/object key to receive this field value when different from fieldName */
      settingsFieldName?: string;
      /** Frontend input type, e.g. text or select */
      inputType?: string;
      /** Should only be used if we have a good idea of what the value will be. */
      defaultValue?: ((string | null) | (number | null) | (boolean | null)) | null;
      /** Inline text description */
      description?: string;
      /** Validation and display config for the setup field */
      config?: {
        /** Regex pattern for string validation */
        pattern?: string;
        /** Whether the field is disabled */
        disabled?: boolean;
        /** Whether a non-empty value is required */
        required?: boolean;
        /** Minimum string length */
        minLength?: number;
        /** Maximum string length */
        maxLength?: number;
      };
      /** Selectable options for select-like input types */
      options?: {
        /** Human-readable option label shown in provider-generated UI */
        label: string;
        /** Value saved for this option by provider-generated UI */
        value: any | null;
        /** Optional help text for this option */
        description?: string;
      }[];
    }[];
    /** Selectable import profiles with display metadata */
    import_profiles: {
      /** Unique provider-scoped profile key */
      key: string;
      title: string;
      description?: string;
      /** Indicates the default profile selection when no key is provided */
      isDefault?: boolean;
      /** Whether this import profile supports provider-defined connection settings candidates */
      supportsCustomSettingsFields?: boolean;
      /** Optional mapping of resource types to profile-aware display labels (e.g., project → list). Frontend templates can reference {provider}, {resourceType}, and {resourceTypePlural}. */
      resourceLabels?: {
        [key: string]: {
          singular: string;
          plural: string;
        };
      };
    }[];
    /** Whether provider supports webhooks for personal connections */
    supports_personal_webhooks: boolean;
    /** Whether provider supports webhooks for account connections */
    supports_account_webhooks: boolean;
  };
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type GetIntegrationDetailsApiArg = {
  /** Provider identifier */
  providerId:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Account ID to get integration details for */
  accountId: string;
};
export type FinalizeIntegrationSetupApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type FinalizeIntegrationSetupApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
  /** Body */
  body: {};
};
export type GetDiffPreviewApiResponse = /** status 200 200 */ {
  data:
    | {
        identities: {
          /** The TIC identity ID */
          id: string;
          verified?: boolean | null;
          /** Connection ID */
          connection_id: string;
          /** The external user id on this `tool_id` */
          external_user_id: ((string | null) | (number | null)) | null;
          /** The external username on origin `tool_id` */
          external_username: string | null;
          /** The external email address on origin `tool_id` */
          external_email: string | null;
          /** DateTime with timezone */
          created_at: string;
          /** DateTime with timezone */
          updated_at: string;
          /** The external users name on origin `tool_id` */
          external_name: string | null;
          /** External timezone */
          external_timezone: string | null;
          /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
          uri: string;
          /** The TIC `tool.id` that this identity belongs to */
          tool_id: string;
          /** The external users avatar URL on origin `tool_id` */
          avatar_url: string | null;
          metadata?: {
            external_role?: string | null;
          };
          /** The TIC `user.id` that has claimed this identity, if any. */
          user_id: string | null;
          user: {
            /** The Timely id version of `user.id`, if known */
            timely_id: number | null;
          };
          connection: {
            /** Connection ID */
            id: string;
            settings: {
              /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
              version?: number | null;
              /** Should new data be auto-subscribed? */
              auto_subscribe?: boolean | null;
              /** How much of the imported data should be stored? Set to minimum for only the essentials. */
              import_data_detail_level?: "default" | "minimum";
              /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
              import_profile_key?: string;
              /** Whether setup wizard is complete and data diff dumping to Timely should be active */
              setup_completed?: boolean | null;
              /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
              setup_settings_configured?: boolean;
              /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
              sync_to_timely?: ("on_demand" | "continuous") | null;
              /** Should projects sync to Timely? */
              sync_projects?: boolean | null;
              /** Should tasks be synced to Timely? */
              sync_tasks?: boolean | null;
              /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
              reference_tasks?: boolean | null;
              /** Should labels be synced to Timely? */
              sync_tags?: boolean | null;
              /** Should clients sync to Timely? */
              sync_clients?: boolean | null;
              /** Should teams sync to Timely? */
              sync_teams?: boolean | null;
              /** Should users sync to Timely? */
              sync_users?: boolean | null;
              /** Should memories be created in TIC? */
              sync_memories?: boolean | null;
              /** Default client ID to assign to imported projects when no client mapping is available */
              fallback_timely_client_id?: number | null;
              /** Provider custom fields that should produce or resolve TIC resource relationships */
              custom_field_mappings?:
                | {
                    /** Provider-scoped mapping identifier */
                    id: string;
                    /** Provider custom field identifier */
                    field_id: string;
                    /** The TIC resource type produced from this provider custom field */
                    target_resource_type: "client";
                    /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                    context?: {
                      [key: string]: string | number | boolean;
                    };
                  }[]
                | null;
              /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
              sync_time_entries?: boolean | null;
              /** Add all workspace users to imported projects */
              project_add_all_workspace_users?: boolean;
              /** Replace vs merge project users on update */
              project_replace_users_on_update?: boolean;
              /** Send invites when adding users to projects */
              project_send_invites?: boolean;
              /** Set required_labels flag on imported projects */
              project_require_labels?: boolean;
              /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
              project_auto_add_assignees_to_projects?: boolean;
              /** Default billing rate type for new projects */
              project_default_rate_type?: "project" | "user" | "non-billable";
              /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
              restrict_tasks_to_assignees?: boolean | null;
            };
            /** DateTime with timezone */
            updated_at: string;
            /** Who can access imported data */
            imported_data_access?: "default" | "everyone";
            /** User ID */
            managing_user_id: string;
            /** The TIC `account.id` */
            account_id?: string;
            account: {
              /** The Timely `account.id` */
              timely_account_id: number | null;
              /** The datetime when the account was last synced with Timely via "auth" operations */
              synced_with_timely_at: string | null;
              /** The TIC `account.id` */
              id: string;
            };
          };
        }[];
        resources: {
          resource: {
            /** TIC resource ID */
            id: string;
            /** Unique resource identifier (synthetic URI) */
            uri: string;
            /** Resource title/name */
            title: string;
            /** Tool ID this resource belongs to */
            tool_id: string;
            /** Resource end/due date */
            end_date: string | null;
            metadata: {
              /** Provider-specific resource type name */
              external_type: string;
              /** Human-readable external ID (e.g., PROJ-123) */
              external_code?: string | null;
              /** Resource description or body text */
              description: string | null;
              /** Resource-specific icon URL */
              icon_url: string | null;
              /** Whether resource supports webhook subscriptions */
              supports_webhooks?: boolean;
              /** Whether resource supports nested subtasks/subitems */
              supports_subitems?: boolean | null;
              /** Resource color (hex or name) */
              color?: string | null;
              /** Associated tags/labels */
              tags?:
                | {
                    /** External tag ID from provider */
                    external_id: string;
                    /** TIC synthetic URI for the tag */
                    uri: string;
                    /** Tag display name */
                    title?: string | null;
                  }[]
                | null;
              /** Primary project reference for task resolution */
              project?: {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              } | null;
              /** Secondary project references for multi-project tasks */
              additional_projects?:
                | {
                    /** External project ID from provider */
                    external_id: string;
                    /** TIC synthetic URI for the project */
                    uri: string;
                  }[]
                | null;
              /** Estimated time in minutes */
              estimated_minutes?: number | null;
              /** Stored client reference from custom field mapping */
              client?: {
                /** Stored TIC client resource URI referenced by this task */
                uri: string;
                /** Stored TIC client external_id, included for diagnostics/provenance */
                external_id?: string;
                /** How this task was linked to the stored client */
                source: {
                  /** Provider that produced the custom-field client reference */
                  provider: string;
                  /** connection.settings.custom_field_mappings[].id used for this match */
                  mapping_id: string;
                  /** Provider custom field identifier used for this match */
                  field_id: string;
                  /** Provider option identifier used for stored client identity */
                  option_id: string;
                  /** Provider-specific mapping context snapshot used to rediscover the field */
                  context?: {
                    [key: string]: string | number | boolean;
                  };
                  /** Provider option label snapshot */
                  option_label?: string | null;
                };
              } | null;
              /** Timely side effects this resource is explicitly allowed to trigger */
              allowed_side_effects?: "project_templates"[];
            };
            /** User-facing web URL */
            url_html: string | null;
            /** When resource was deleted */
            deleted_at: string | null;
            /** Resource start date */
            start_date: string | null;
            /** TIC record last-updated timestamp */
            updated_at: string;
            /** When resource was archived */
            archived_at: string | null;
            /** External source ID */
            external_id?: string | null;
            /** When resource was completed */
            completed_at: string | null;
            type:
              | "project"
              | "task"
              | "label"
              | "tag"
              | "team"
              | "client"
              | "company"
              | "organization"
              | "identity";
          };
          resource_permissions?: {
            /** The TIC `resource_permissions.id` reference, to make updates to relationship easier */
            id: string | null;
            /** The Timely id version of `resource.id`, if resource has created a Timely data model */
            timely_id: number | null;
          };
          resource_root: {
            /** TIC resource ID */
            id: string;
            /** Unique resource identifier (synthetic URI) */
            uri: string;
            type:
              | "project"
              | "task"
              | "label"
              | "tag"
              | "team"
              | "client"
              | "company"
              | "organization"
              | "identity";
            /** Resource title/name */
            title: string;
          } | null;
          resource_parent: {
            /** TIC resource ID */
            id: string;
            /** Unique resource identifier (synthetic URI) */
            uri: string;
            type:
              | "project"
              | "task"
              | "label"
              | "tag"
              | "team"
              | "client"
              | "company"
              | "organization"
              | "identity";
            /** Resource title/name */
            title: string;
          } | null;
          resource_children:
            | {
                /** TIC resource ID */
                id: string;
                /** Unique resource identifier (synthetic URI) */
                uri: string;
                type:
                  | "project"
                  | "task"
                  | "label"
                  | "tag"
                  | "team"
                  | "client"
                  | "company"
                  | "organization"
                  | "identity";
                /** Resource title/name */
                title: string;
              }[]
            | null;
          connection: {
            /** Connection ID */
            id: string;
            settings: {
              /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
              version?: number | null;
              /** Should new data be auto-subscribed? */
              auto_subscribe?: boolean | null;
              /** How much of the imported data should be stored? Set to minimum for only the essentials. */
              import_data_detail_level?: "default" | "minimum";
              /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
              import_profile_key?: string;
              /** Whether setup wizard is complete and data diff dumping to Timely should be active */
              setup_completed?: boolean | null;
              /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
              setup_settings_configured?: boolean;
              /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
              sync_to_timely?: ("on_demand" | "continuous") | null;
              /** Should projects sync to Timely? */
              sync_projects?: boolean | null;
              /** Should tasks be synced to Timely? */
              sync_tasks?: boolean | null;
              /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
              reference_tasks?: boolean | null;
              /** Should labels be synced to Timely? */
              sync_tags?: boolean | null;
              /** Should clients sync to Timely? */
              sync_clients?: boolean | null;
              /** Should teams sync to Timely? */
              sync_teams?: boolean | null;
              /** Should users sync to Timely? */
              sync_users?: boolean | null;
              /** Should memories be created in TIC? */
              sync_memories?: boolean | null;
              /** Default client ID to assign to imported projects when no client mapping is available */
              fallback_timely_client_id?: number | null;
              /** Provider custom fields that should produce or resolve TIC resource relationships */
              custom_field_mappings?:
                | {
                    /** Provider-scoped mapping identifier */
                    id: string;
                    /** Provider custom field identifier */
                    field_id: string;
                    /** The TIC resource type produced from this provider custom field */
                    target_resource_type: "client";
                    /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                    context?: {
                      [key: string]: string | number | boolean;
                    };
                  }[]
                | null;
              /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
              sync_time_entries?: boolean | null;
              /** Add all workspace users to imported projects */
              project_add_all_workspace_users?: boolean;
              /** Replace vs merge project users on update */
              project_replace_users_on_update?: boolean;
              /** Send invites when adding users to projects */
              project_send_invites?: boolean;
              /** Set required_labels flag on imported projects */
              project_require_labels?: boolean;
              /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
              project_auto_add_assignees_to_projects?: boolean;
              /** Default billing rate type for new projects */
              project_default_rate_type?: "project" | "user" | "non-billable";
              /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
              restrict_tasks_to_assignees?: boolean | null;
            };
            /** DateTime with timezone */
            updated_at: string;
            /** Who can access imported data */
            imported_data_access?: "default" | "everyone";
            /** User ID */
            managing_user_id: string;
            /** The TIC `account.id` */
            account_id?: string;
          };
          subscription: {
            id: string;
            enabled: boolean;
            synced_at: string | null;
          };
          account: {
            /** The Timely `account.id` */
            timely_account_id: number | null;
            /** The datetime when the account was last synced with Timely via "auth" operations */
            synced_with_timely_at: string | null;
            /** The TIC `account.id` */
            id: string;
          };
          user_associations:
            | {
                /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
                identity_uri: string;
                /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
                tic_identity_id: string | null;
                /** The TIC `user/profile.id` reference to the user, if known */
                tic_user_id: string | null;
                /** The date of last update of this association */
                updated_at: string;
              }[]
            | null;
        }[];
      }
    | {
        identities: {
          type: "identity";
          /** The TIC identity ID */
          tic_id: string;
          /** The TIC `user.id` associate to this identity, if known */
          tic_user_id: string | null;
          /** The Timely `user.id` reference to the user, if known */
          timely_user_id: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
          uri: string;
          /** The external user id on this `tool_id` */
          external_id: ((string | null) | (number | null)) | null;
          /** The external email address on origin `tool_id` */
          external_email: string | null;
          /** The external users name on origin `tool_id` */
          external_name: string | null;
          /** The TIC `tool.id` that this identity belongs to */
          external_tool_id: string;
          /** External timezone */
          external_timezone: string | null;
          metadata?: {
            external_role?: string | null;
          };
        }[];
        labels: {
          type: "label";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The label name */
          name: string;
          parent_label: {
            /** The TIC URI of the parent label (preferred identifier) */
            uri?: string | null;
            /** The TIC resource ID of the parent label */
            tic_id?: string | null;
            /** The external ID of the parent label (fallback identifier) */
            external_id?: string | null;
          };
        }[];
        companies: {
          type: "client";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The client name */
          name: string;
          /** Is active?. Set false to archive client */
          active: boolean;
        }[];
        projects: {
          type: "project";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The project name */
          name: string;
          /** The project description, if available */
          description?: string | null;
          /** The project color, if known */
          color?: string | null;
          /** Is active? Turn false to archive project automatically */
          active: boolean;
          /** References to the company (aka "client") for this project */
          company: {
            /** The TIC `resource.id` reference to the company ("client") */
            tic_id: string | null;
            /** The Timely ID of the company ("client"), if known */
            timely_id: number | null;
            /** The fallback Timely `client_id` to use if `timely_id` is not supplied */
            fallback_timely_id?: number | null;
            /** The project's parent `resource.title`, useful for assigning to existing clients with same name on Timely side. Beware the potential instability of this (e.g parent is renamed externally) */
            fallback_title?: string | null;
          } | null;
          users:
            | {
                /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
                identity_uri: string;
                /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
                tic_identity_id: string | null;
                /** The TIC `user/profile.id` reference to the user, if known */
                tic_user_id: string | null;
                /** The date of last update of this association */
                updated_at: string;
              }[]
            | null;
          /** Label associations attached to the resource. Defaults to an empty list. These labels are attached directly on the resource metadata and do not have DB-relationships */
          labels?: {
            /** The TIC `resource.id` reference to the label */
            tic_id?: string;
            /** The provider label identifier, used as a fallback when tic_id is unavailable */
            external_id?: string;
            /** The TIC URI reference to the label, useful for cross-diff reconciliation */
            uri?: string;
            title?: string | null;
          }[];
        }[];
        tasks: {
          type: "forecast";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The forecast title */
          title: string;
          /** The forecast description */
          description: string;
          /** The forecast start date */
          from: string | null;
          /** The forecast end date */
          to: string | null;
          /** The estimated minutes of the forecast */
          estimated_minutes?: number;
          /** The completed date of the forecast */
          completed_at: string | null;
          users: {
            /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
            identity_uri: string;
            /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
            tic_identity_id: string | null;
            /** The TIC `user/profile.id` reference to the user, if known */
            tic_user_id: string | null;
            /** The date of last update of this association */
            updated_at: string;
          }[];
          /** Label associations attached to the resource. Defaults to an empty list. These labels are attached directly on the resource metadata and do not have DB-relationships */
          labels?: {
            /** The TIC `resource.id` reference to the label */
            tic_id?: string;
            /** The provider label identifier, used as a fallback when tic_id is unavailable */
            external_id?: string;
            /** The TIC URI reference to the label, useful for cross-diff reconciliation */
            uri?: string;
            title?: string | null;
          }[];
          project: {
            /** The TIC `resource.id` reference of project */
            tic_id: string | null;
            /** The TIC URI reference to the project, for cross-diff reconciliation */
            uri?: string | null;
            /** The provider project identifier, used as a last-resort fallback */
            external_id?: string | null;
          };
        }[];
        teams: {
          type: "team";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The team name */
          name: string;
          description?: string;
          /** Is active? Set false to archive team */
          active: boolean;
          users: {
            /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
            identity_uri: string;
            /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
            tic_identity_id: string | null;
            /** The TIC `user/profile.id` reference to the user, if known */
            tic_user_id: string | null;
            /** The date of last update of this association */
            updated_at: string;
          }[];
        }[];
      };
  meta: {
    /** Unique identifier for the request */
    requestId: string;
    /** Duration of the operation in milliseconds */
    duration: number;
    /** Human-readable status message */
    message: string;
    /** Number of records processed */
    count: number;
    /** Whether any data was found to diff */
    foundDataToDiff: boolean;
    /** The RPC query parameters used */
    query: {
      allowed_types: (
        | "project"
        | "task"
        | "label"
        | "tag"
        | "team"
        | "client"
        | "company"
        | "organization"
        | "identity"
      )[];
      /** DateTime with timezone */
      updated_after: string;
      /** DateTime with timezone */
      updated_before: string;
      /** Page number for pagination, starting at 1 */
      page?: number | null;
      /** Number of records we query per page (250 default, down from 500) */
      per_page?: number | null;
      /** If set, limits the diff to only resources belonging to this TIC account. Does NOT produce "trusted" diff */
      limit_to_account_id?: string;
      /** If set, limits the diff to only resources belonging to this TIC connection. Does NOT produce "trusted" diff */
      limit_to_connection_id?: string;
      limit_to_identity_ids?: string[];
      /** Whether to include all data or only incremental changes based on last_synced_at timestamps */
      include_all_data?: boolean;
    };
  };
};
export type GetDiffPreviewApiArg = {
  /** Provider identifier */
  providerId:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
  /** The Timely `account.id` */
  timelyAccountId?: number;
  /** Response format */
  format?: "raw_data" | "timely_format";
  /** Filter results to specific resource types. If not provided, all supported types are included. */
  resourceTypes?: (
    | "project"
    | "task"
    | "label"
    | "tag"
    | "team"
    | "client"
    | "company"
    | "organization"
    | "identity"
  )[];
};
export type RegenerateFullDiffApiResponse = /** status 202 202 */ {
  message: string;
  trigger_run_id: string;
};
export type RegenerateFullDiffApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
  /** Filter regeneration to specific resource types. If omitted, all supported types are included. */
  resourceTypes?: (
    | "project"
    | "task"
    | "label"
    | "tag"
    | "team"
    | "client"
    | "company"
    | "organization"
    | "identity"
  )[];
  /** Body */
  body: {};
};
export type GetConnectionJobsApiResponse = /** status 200 200 */ {
  data: {
    id: string;
    name: string;
    state: "created" | "retry" | "active" | "completed" | "cancelled" | "failed";
    retryCount: number;
    createdOn: string;
    startedOn: string | null;
    completedOn: string | null;
    heartbeatOn: string | null;
    expireSeconds: number | null;
    policy: string | null;
    data?: any | null;
  }[];
};
export type GetConnectionJobsApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
  /** When true, also return jobs completed within the last hour */
  includeRecent?: boolean;
};
export type GetConnectionSyncRunProgressApiResponse = /** status 200 200 */ {
  data: {
    id: string;
    connection_id: string;
    preset: "initialize" | "synchronize" | "operations" | "webhook";
    status: "running" | "completed" | "completed_with_errors" | "failed";
    outstanding: number;
    ok_count: number;
    error_count: number;
    started_at: string | null;
    finished_at: string | null;
    finalized_at: string | null;
    updated_at: string;
  }[];
};
export type GetConnectionSyncRunProgressApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
};
export type GetConnectionSyncRunsApiResponse = /** status 200 200 */ {
  data: {
    id: string;
    connection_id: string;
    preset: "initialize" | "synchronize" | "operations" | "webhook";
    status: "running" | "completed" | "completed_with_errors" | "failed";
    outstanding: number;
    ok_count: number;
    error_count: number;
    started_at: string | null;
    finished_at: string | null;
    finalized_at: string | null;
    updated_at: string;
  }[];
};
export type GetConnectionSyncRunsApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
};
export type GetDiffsListApiResponse = /** status 200 200 */ {
  data: {
    diffs: {
      id: string;
      generated_at: string;
      status: "created" | "in_progress" | "success" | "failed";
      error: string | null;
      failed_count: number;
      /** The Timely `account.id` */
      timely_account_id: number | null;
      processed_by_timely_at: string | null;
      trust_generated_at: boolean;
      resource_count: number;
    }[];
    latestGeneratedAt: string | null;
    totalDiffsCount: number;
    pendingDiffsCount: number;
    failedDiffsCount: number;
  };
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    page: number;
  };
};
export type GetDiffsListApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Connection ID */
  connectionId: string;
  /** Page number */
  page?: number;
  /** Results per page */
  perPage?: number;
};
export type GetDiffDetailsApiResponse = /** status 200 200 */ {
  id: string;
  generated_at: string;
  status: "created" | "in_progress" | "success" | "failed";
  error: string | null;
  failed_count: number;
  /** The Timely `account.id` */
  timely_account_id: number | null;
  processed_by_timely_at: string | null;
  data:
    | {
        identities: {
          /** The TIC identity ID */
          id: string;
          verified?: boolean | null;
          /** Connection ID */
          connection_id: string;
          /** The external user id on this `tool_id` */
          external_user_id: ((string | null) | (number | null)) | null;
          /** The external username on origin `tool_id` */
          external_username: string | null;
          /** The external email address on origin `tool_id` */
          external_email: string | null;
          /** DateTime with timezone */
          created_at: string;
          /** DateTime with timezone */
          updated_at: string;
          /** The external users name on origin `tool_id` */
          external_name: string | null;
          /** External timezone */
          external_timezone: string | null;
          /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
          uri: string;
          /** The TIC `tool.id` that this identity belongs to */
          tool_id: string;
          /** The external users avatar URL on origin `tool_id` */
          avatar_url: string | null;
          metadata?: {
            external_role?: string | null;
          };
          /** The TIC `user.id` that has claimed this identity, if any. */
          user_id: string | null;
          user: {
            /** The Timely id version of `user.id`, if known */
            timely_id: number | null;
          };
          connection: {
            /** Connection ID */
            id: string;
            settings: {
              /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
              version?: number | null;
              /** Should new data be auto-subscribed? */
              auto_subscribe?: boolean | null;
              /** How much of the imported data should be stored? Set to minimum for only the essentials. */
              import_data_detail_level?: "default" | "minimum";
              /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
              import_profile_key?: string;
              /** Whether setup wizard is complete and data diff dumping to Timely should be active */
              setup_completed?: boolean | null;
              /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
              setup_settings_configured?: boolean;
              /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
              sync_to_timely?: ("on_demand" | "continuous") | null;
              /** Should projects sync to Timely? */
              sync_projects?: boolean | null;
              /** Should tasks be synced to Timely? */
              sync_tasks?: boolean | null;
              /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
              reference_tasks?: boolean | null;
              /** Should labels be synced to Timely? */
              sync_tags?: boolean | null;
              /** Should clients sync to Timely? */
              sync_clients?: boolean | null;
              /** Should teams sync to Timely? */
              sync_teams?: boolean | null;
              /** Should users sync to Timely? */
              sync_users?: boolean | null;
              /** Should memories be created in TIC? */
              sync_memories?: boolean | null;
              /** Default client ID to assign to imported projects when no client mapping is available */
              fallback_timely_client_id?: number | null;
              /** Provider custom fields that should produce or resolve TIC resource relationships */
              custom_field_mappings?:
                | {
                    /** Provider-scoped mapping identifier */
                    id: string;
                    /** Provider custom field identifier */
                    field_id: string;
                    /** The TIC resource type produced from this provider custom field */
                    target_resource_type: "client";
                    /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                    context?: {
                      [key: string]: string | number | boolean;
                    };
                  }[]
                | null;
              /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
              sync_time_entries?: boolean | null;
              /** Add all workspace users to imported projects */
              project_add_all_workspace_users?: boolean;
              /** Replace vs merge project users on update */
              project_replace_users_on_update?: boolean;
              /** Send invites when adding users to projects */
              project_send_invites?: boolean;
              /** Set required_labels flag on imported projects */
              project_require_labels?: boolean;
              /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
              project_auto_add_assignees_to_projects?: boolean;
              /** Default billing rate type for new projects */
              project_default_rate_type?: "project" | "user" | "non-billable";
              /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
              restrict_tasks_to_assignees?: boolean | null;
            };
            /** DateTime with timezone */
            updated_at: string;
            /** Who can access imported data */
            imported_data_access?: "default" | "everyone";
            /** User ID */
            managing_user_id: string;
            /** The TIC `account.id` */
            account_id?: string;
            account: {
              /** The Timely `account.id` */
              timely_account_id: number | null;
              /** The datetime when the account was last synced with Timely via "auth" operations */
              synced_with_timely_at: string | null;
              /** The TIC `account.id` */
              id: string;
            };
          };
        }[];
        resources: {
          resource: {
            /** TIC resource ID */
            id: string;
            /** Unique resource identifier (synthetic URI) */
            uri: string;
            /** Resource title/name */
            title: string;
            /** Tool ID this resource belongs to */
            tool_id: string;
            /** Resource end/due date */
            end_date: string | null;
            metadata: {
              /** Provider-specific resource type name */
              external_type: string;
              /** Human-readable external ID (e.g., PROJ-123) */
              external_code?: string | null;
              /** Resource description or body text */
              description: string | null;
              /** Resource-specific icon URL */
              icon_url: string | null;
              /** Whether resource supports webhook subscriptions */
              supports_webhooks?: boolean;
              /** Whether resource supports nested subtasks/subitems */
              supports_subitems?: boolean | null;
              /** Resource color (hex or name) */
              color?: string | null;
              /** Associated tags/labels */
              tags?:
                | {
                    /** External tag ID from provider */
                    external_id: string;
                    /** TIC synthetic URI for the tag */
                    uri: string;
                    /** Tag display name */
                    title?: string | null;
                  }[]
                | null;
              /** Primary project reference for task resolution */
              project?: {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              } | null;
              /** Secondary project references for multi-project tasks */
              additional_projects?:
                | {
                    /** External project ID from provider */
                    external_id: string;
                    /** TIC synthetic URI for the project */
                    uri: string;
                  }[]
                | null;
              /** Estimated time in minutes */
              estimated_minutes?: number | null;
              /** Stored client reference from custom field mapping */
              client?: {
                /** Stored TIC client resource URI referenced by this task */
                uri: string;
                /** Stored TIC client external_id, included for diagnostics/provenance */
                external_id?: string;
                /** How this task was linked to the stored client */
                source: {
                  /** Provider that produced the custom-field client reference */
                  provider: string;
                  /** connection.settings.custom_field_mappings[].id used for this match */
                  mapping_id: string;
                  /** Provider custom field identifier used for this match */
                  field_id: string;
                  /** Provider option identifier used for stored client identity */
                  option_id: string;
                  /** Provider-specific mapping context snapshot used to rediscover the field */
                  context?: {
                    [key: string]: string | number | boolean;
                  };
                  /** Provider option label snapshot */
                  option_label?: string | null;
                };
              } | null;
              /** Timely side effects this resource is explicitly allowed to trigger */
              allowed_side_effects?: "project_templates"[];
            };
            /** User-facing web URL */
            url_html: string | null;
            /** When resource was deleted */
            deleted_at: string | null;
            /** Resource start date */
            start_date: string | null;
            /** TIC record last-updated timestamp */
            updated_at: string;
            /** When resource was archived */
            archived_at: string | null;
            /** External source ID */
            external_id?: string | null;
            /** When resource was completed */
            completed_at: string | null;
            type:
              | "project"
              | "task"
              | "label"
              | "tag"
              | "team"
              | "client"
              | "company"
              | "organization"
              | "identity";
          };
          resource_permissions?: {
            /** The TIC `resource_permissions.id` reference, to make updates to relationship easier */
            id: string | null;
            /** The Timely id version of `resource.id`, if resource has created a Timely data model */
            timely_id: number | null;
          };
          resource_root: {
            /** TIC resource ID */
            id: string;
            /** Unique resource identifier (synthetic URI) */
            uri: string;
            type:
              | "project"
              | "task"
              | "label"
              | "tag"
              | "team"
              | "client"
              | "company"
              | "organization"
              | "identity";
            /** Resource title/name */
            title: string;
          } | null;
          resource_parent: {
            /** TIC resource ID */
            id: string;
            /** Unique resource identifier (synthetic URI) */
            uri: string;
            type:
              | "project"
              | "task"
              | "label"
              | "tag"
              | "team"
              | "client"
              | "company"
              | "organization"
              | "identity";
            /** Resource title/name */
            title: string;
          } | null;
          resource_children:
            | {
                /** TIC resource ID */
                id: string;
                /** Unique resource identifier (synthetic URI) */
                uri: string;
                type:
                  | "project"
                  | "task"
                  | "label"
                  | "tag"
                  | "team"
                  | "client"
                  | "company"
                  | "organization"
                  | "identity";
                /** Resource title/name */
                title: string;
              }[]
            | null;
          connection: {
            /** Connection ID */
            id: string;
            settings: {
              /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
              version?: number | null;
              /** Should new data be auto-subscribed? */
              auto_subscribe?: boolean | null;
              /** How much of the imported data should be stored? Set to minimum for only the essentials. */
              import_data_detail_level?: "default" | "minimum";
              /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
              import_profile_key?: string;
              /** Whether setup wizard is complete and data diff dumping to Timely should be active */
              setup_completed?: boolean | null;
              /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
              setup_settings_configured?: boolean;
              /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
              sync_to_timely?: ("on_demand" | "continuous") | null;
              /** Should projects sync to Timely? */
              sync_projects?: boolean | null;
              /** Should tasks be synced to Timely? */
              sync_tasks?: boolean | null;
              /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
              reference_tasks?: boolean | null;
              /** Should labels be synced to Timely? */
              sync_tags?: boolean | null;
              /** Should clients sync to Timely? */
              sync_clients?: boolean | null;
              /** Should teams sync to Timely? */
              sync_teams?: boolean | null;
              /** Should users sync to Timely? */
              sync_users?: boolean | null;
              /** Should memories be created in TIC? */
              sync_memories?: boolean | null;
              /** Default client ID to assign to imported projects when no client mapping is available */
              fallback_timely_client_id?: number | null;
              /** Provider custom fields that should produce or resolve TIC resource relationships */
              custom_field_mappings?:
                | {
                    /** Provider-scoped mapping identifier */
                    id: string;
                    /** Provider custom field identifier */
                    field_id: string;
                    /** The TIC resource type produced from this provider custom field */
                    target_resource_type: "client";
                    /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
                    context?: {
                      [key: string]: string | number | boolean;
                    };
                  }[]
                | null;
              /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
              sync_time_entries?: boolean | null;
              /** Add all workspace users to imported projects */
              project_add_all_workspace_users?: boolean;
              /** Replace vs merge project users on update */
              project_replace_users_on_update?: boolean;
              /** Send invites when adding users to projects */
              project_send_invites?: boolean;
              /** Set required_labels flag on imported projects */
              project_require_labels?: boolean;
              /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
              project_auto_add_assignees_to_projects?: boolean;
              /** Default billing rate type for new projects */
              project_default_rate_type?: "project" | "user" | "non-billable";
              /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
              restrict_tasks_to_assignees?: boolean | null;
            };
            /** DateTime with timezone */
            updated_at: string;
            /** Who can access imported data */
            imported_data_access?: "default" | "everyone";
            /** User ID */
            managing_user_id: string;
            /** The TIC `account.id` */
            account_id?: string;
          };
          subscription: {
            id: string;
            enabled: boolean;
            synced_at: string | null;
          };
          account: {
            /** The Timely `account.id` */
            timely_account_id: number | null;
            /** The datetime when the account was last synced with Timely via "auth" operations */
            synced_with_timely_at: string | null;
            /** The TIC `account.id` */
            id: string;
          };
          user_associations:
            | {
                /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
                identity_uri: string;
                /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
                tic_identity_id: string | null;
                /** The TIC `user/profile.id` reference to the user, if known */
                tic_user_id: string | null;
                /** The date of last update of this association */
                updated_at: string;
              }[]
            | null;
        }[];
      }
    | {
        identities: {
          type: "identity";
          /** The TIC identity ID */
          tic_id: string;
          /** The TIC `user.id` associate to this identity, if known */
          tic_user_id: string | null;
          /** The Timely `user.id` reference to the user, if known */
          timely_user_id: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
          uri: string;
          /** The external user id on this `tool_id` */
          external_id: ((string | null) | (number | null)) | null;
          /** The external email address on origin `tool_id` */
          external_email: string | null;
          /** The external users name on origin `tool_id` */
          external_name: string | null;
          /** The TIC `tool.id` that this identity belongs to */
          external_tool_id: string;
          /** External timezone */
          external_timezone: string | null;
          metadata?: {
            external_role?: string | null;
          };
        }[];
        labels: {
          type: "label";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The label name */
          name: string;
          parent_label: {
            /** The TIC URI of the parent label (preferred identifier) */
            uri?: string | null;
            /** The TIC resource ID of the parent label */
            tic_id?: string | null;
            /** The external ID of the parent label (fallback identifier) */
            external_id?: string | null;
          };
        }[];
        companies: {
          type: "client";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The client name */
          name: string;
          /** Is active?. Set false to archive client */
          active: boolean;
        }[];
        projects: {
          type: "project";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The project name */
          name: string;
          /** The project description, if available */
          description?: string | null;
          /** The project color, if known */
          color?: string | null;
          /** Is active? Turn false to archive project automatically */
          active: boolean;
          /** References to the company (aka "client") for this project */
          company: {
            /** The TIC `resource.id` reference to the company ("client") */
            tic_id: string | null;
            /** The Timely ID of the company ("client"), if known */
            timely_id: number | null;
            /** The fallback Timely `client_id` to use if `timely_id` is not supplied */
            fallback_timely_id?: number | null;
            /** The project's parent `resource.title`, useful for assigning to existing clients with same name on Timely side. Beware the potential instability of this (e.g parent is renamed externally) */
            fallback_title?: string | null;
          } | null;
          users:
            | {
                /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
                identity_uri: string;
                /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
                tic_identity_id: string | null;
                /** The TIC `user/profile.id` reference to the user, if known */
                tic_user_id: string | null;
                /** The date of last update of this association */
                updated_at: string;
              }[]
            | null;
          /** Label associations attached to the resource. Defaults to an empty list. These labels are attached directly on the resource metadata and do not have DB-relationships */
          labels?: {
            /** The TIC `resource.id` reference to the label */
            tic_id?: string;
            /** The provider label identifier, used as a fallback when tic_id is unavailable */
            external_id?: string;
            /** The TIC URI reference to the label, useful for cross-diff reconciliation */
            uri?: string;
            title?: string | null;
          }[];
        }[];
        tasks: {
          type: "forecast";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The forecast title */
          title: string;
          /** The forecast description */
          description: string;
          /** The forecast start date */
          from: string | null;
          /** The forecast end date */
          to: string | null;
          /** The estimated minutes of the forecast */
          estimated_minutes?: number;
          /** The completed date of the forecast */
          completed_at: string | null;
          users: {
            /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
            identity_uri: string;
            /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
            tic_identity_id: string | null;
            /** The TIC `user/profile.id` reference to the user, if known */
            tic_user_id: string | null;
            /** The date of last update of this association */
            updated_at: string;
          }[];
          /** Label associations attached to the resource. Defaults to an empty list. These labels are attached directly on the resource metadata and do not have DB-relationships */
          labels?: {
            /** The TIC `resource.id` reference to the label */
            tic_id?: string;
            /** The provider label identifier, used as a fallback when tic_id is unavailable */
            external_id?: string;
            /** The TIC URI reference to the label, useful for cross-diff reconciliation */
            uri?: string;
            title?: string | null;
          }[];
          project: {
            /** The TIC `resource.id` reference of project */
            tic_id: string | null;
            /** The TIC URI reference to the project, for cross-diff reconciliation */
            uri?: string | null;
            /** The provider project identifier, used as a last-resort fallback */
            external_id?: string | null;
          };
        }[];
        teams: {
          type: "team";
          /** The URL of the resource, if known */
          url: string | null;
          /** The TIC `id` reference to the resource */
          tic_id: string;
          /** The TIC URI of the resource; prefer this to `tic_id` when possible */
          uri?: string | null;
          /** The Timely ID of the resource, if known */
          timely_id?: number | null;
          /** The Timely `account.id` */
          timely_account_id: number;
          /** The TIC `account.id` this resource belongs to */
          tic_account_id: string;
          /** The TIC user ID of the creator */
          creator_tic_user_id: string | null;
          /** The external ID of the resource */
          external_id: string;
          /** The TIC `tool.id` driving the import */
          external_tool_id: string;
          /** When this resource was last updated. WARNING: CURRENTLY, this does not _necessarily_ reflect the external source's last update, but that is the intent. */
          updated_at: string;
          /** Per-resource sync guidance for Timely */
          sync_options?: {
            /** Projects: add all Timely account users */
            add_all_workspace_users?: boolean;
            /** Projects: replace vs merge user list */
            replace_users_on_update?: boolean;
            /** Projects: email invites for new users */
            send_invites?: boolean;
            /** Projects: enforce required_labels flag */
            require_labels?: boolean;
            /** Projects: label visibility policy (all = show all workspace tags) */
            enable_labels?: "all" | "none" | "custom";
            /** Projects: billing rate type on creation */
            default_rate_type?: "project" | "user" | "non-billable";
            /** Forecasts: when importing tasks with assignees that are not members of the project, auto-add them to the project before importing the task. */
            auto_add_assignees_to_projects?: boolean;
            /** Side effects this resource is explicitly allowed to trigger in Timely */
            allowed_side_effects?: "project_templates"[];
          };
          /** The team name */
          name: string;
          description?: string;
          /** Is active? Set false to archive team */
          active: boolean;
          users: {
            /** The URI to the identity on the external service (can be a standard URL or TIC URI like tic://provider/identities/id) */
            identity_uri: string;
            /** The TIC identity.id _SHOULDNT_ be null, likely local seeding setup issue, so allowing through. */
            tic_identity_id: string | null;
            /** The TIC `user/profile.id` reference to the user, if known */
            tic_user_id: string | null;
            /** The date of last update of this association */
            updated_at: string;
          }[];
        }[];
      };
  processed_output: {
    diff_id: string;
    /** The Timely `account.id` */
    timely_account_id: number;
    status: "success" | "failed";
    error: string | null;
    failed_count: number;
    data: {
      [key: string]: any;
    }[];
  } | null;
};
export type GetDiffDetailsApiArg = {
  /** Provider identifier */
  provider:
    | "asana"
    | "clickup"
    | "github"
    | "jira"
    | "linear"
    | "monday"
    | "salesforce"
    | "salesforce-sandbox"
    | "trello"
    | "base";
  /** Diff identifier */
  diffId: string;
  /** Connection ID */
  connectionId: string;
  /** Response format */
  format?: "raw_data" | "timely_format";
};
export type UpdateConnectionIdApiResponse = /** status 200 200 */ {
  /** Connection display name */
  title: string | null;
  /** The scope of the integration */
  scope: "personal" | "account";
  /** Who can access imported data */
  imported_data_access?: "default" | "everyone";
  /** Tool ID */
  tool_id: string;
  /** TIC account ID */
  account_id: string;
  /** User ID */
  managing_user_id: string;
  /** Nango internal connection ID */
  nango_id: number | null;
  /** Nango connection reference ID */
  nango_connection_id: string | null;
  /** When connection was disconnected */
  disconnected_at?: string | null;
  /** Reason for disconnection */
  disconnection_reason:
    | (
        | "authentication_failed"
        | "nango_refresh_exhausted"
        | "nango_connection_deleted"
        | "missing_identity_claim"
      )
    | null;
  metadata: {
    [key: string]: {
      when?: string;
      error?: ((string | null) | (boolean | null)) | null;
      executionSeconds?: number | null;
      lastXhr?: {
        when?: string;
        url: string;
        lastRecordId?: ((string | null) | (number | null)) | null;
        firstRecordId?: ((string | null) | (number | null)) | null;
        firstFewRecordsFingerprint?: ((string | null) | (number | null)) | null;
        status?: number;
        lastModified?: string;
        eTag?: string | null;
        eTags?: string[] | null;
        cursor?: ((string | null) | (number | null)) | null;
        rateLimit?: ((number | null) | (string | null)) | null;
        rateLimitRemaining?: ((number | null) | (string | null)) | null;
        nextUrl?: string;
      };
      /** The operationId that the provider supports */
      operationId?:
        | "importClients"
        | "importClient"
        | "importProjects"
        | "importProject"
        | "importProjectPermissions"
        | "importTasks"
        | "importTask"
        | "importLabels"
        | "importTeams"
        | "importTeam"
        | "importOrganizations"
        | "importOrganization"
        | "importIdentities"
        | "importIdentity"
        | "importPullRequests"
        | "importPullRequest"
        | "importMemories"
        | "syncWebhookDefinitions"
        | "syncWebhooks"
        | "handleIncomingWebhook"
        | "getCustomSettingsFields";
    };
  };
  /** The (Nango) configuration for a connection */
  config: {
    [key: string]: string | null;
  };
  settings: {
    /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
    version?: number | null;
    /** Should new data be auto-subscribed? */
    auto_subscribe?: boolean | null;
    /** How much of the imported data should be stored? Set to minimum for only the essentials. */
    import_data_detail_level?: "default" | "minimum";
    /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
    import_profile_key?: string;
    /** Whether setup wizard is complete and data diff dumping to Timely should be active */
    setup_completed?: boolean | null;
    /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
    setup_settings_configured?: boolean;
    /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
    sync_to_timely?: ("on_demand" | "continuous") | null;
    /** Should projects sync to Timely? */
    sync_projects?: boolean | null;
    /** Should tasks be synced to Timely? */
    sync_tasks?: boolean | null;
    /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
    reference_tasks?: boolean | null;
    /** Should labels be synced to Timely? */
    sync_tags?: boolean | null;
    /** Should clients sync to Timely? */
    sync_clients?: boolean | null;
    /** Should teams sync to Timely? */
    sync_teams?: boolean | null;
    /** Should users sync to Timely? */
    sync_users?: boolean | null;
    /** Should memories be created in TIC? */
    sync_memories?: boolean | null;
    /** Default client ID to assign to imported projects when no client mapping is available */
    fallback_timely_client_id?: number | null;
    /** Provider custom fields that should produce or resolve TIC resource relationships */
    custom_field_mappings?:
      | {
          /** Provider-scoped mapping identifier */
          id: string;
          /** Provider custom field identifier */
          field_id: string;
          /** The TIC resource type produced from this provider custom field */
          target_resource_type: "client";
          /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
          context?: {
            [key: string]: string | number | boolean;
          };
        }[]
      | null;
    /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
    sync_time_entries?: boolean | null;
    /** Add all workspace users to imported projects */
    project_add_all_workspace_users?: boolean;
    /** Replace vs merge project users on update */
    project_replace_users_on_update?: boolean;
    /** Send invites when adding users to projects */
    project_send_invites?: boolean;
    /** Set required_labels flag on imported projects */
    project_require_labels?: boolean;
    /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
    project_auto_add_assignees_to_projects?: boolean;
    /** Default billing rate type for new projects */
    project_default_rate_type?: "project" | "user" | "non-billable";
    /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
    restrict_tasks_to_assignees?: boolean | null;
  };
  /** Connection ID */
  id: string;
  /** DateTime with timezone */
  created_at: string;
  /** DateTime with timezone */
  updated_at: string;
};
export type UpdateConnectionIdApiArg = {
  /** Connection ID */
  connectionId: string;
  /** Body */
  body: {
    /** Connection ID */
    id: string;
    settings: {
      /** Version of the connection settings schema; Increment this when making changes to the schema to simplify SQL migrations that backfill existing connections with new settings. */
      version?: number | null;
      /** Should new data be auto-subscribed? */
      auto_subscribe?: boolean | null;
      /** How much of the imported data should be stored? Set to minimum for only the essentials. */
      import_data_detail_level?: "default" | "minimum";
      /** Profile key used to scope imported resources (e.g. Trello board vs. client hierarchy). */
      import_profile_key?: string;
      /** Whether setup wizard is complete and data diff dumping to Timely should be active */
      setup_completed?: boolean | null;
      /** Internal wizard marker: whether initial sync settings defaults have been written to this connection. Used to avoid re-applying operation defaults when resuming setup. */
      setup_settings_configured?: boolean;
      /** How should the connection sync with Timely? `null` disables syncing (uninstalling any webhooks as well), `on_demand` has no webhooks and dumps once to Timely, `continuous` installs webhooks and creates content in Timely automatically */
      sync_to_timely?: ("on_demand" | "continuous") | null;
      /** Should projects sync to Timely? */
      sync_projects?: boolean | null;
      /** Should tasks be synced to Timely? */
      sync_tasks?: boolean | null;
      /** Should tasks be available as **references** when logging time? Does NOT require `sync_tasks` to be enabled. Timely tasks are not created. */
      reference_tasks?: boolean | null;
      /** Should labels be synced to Timely? */
      sync_tags?: boolean | null;
      /** Should clients sync to Timely? */
      sync_clients?: boolean | null;
      /** Should teams sync to Timely? */
      sync_teams?: boolean | null;
      /** Should users sync to Timely? */
      sync_users?: boolean | null;
      /** Should memories be created in TIC? */
      sync_memories?: boolean | null;
      /** Default client ID to assign to imported projects when no client mapping is available */
      fallback_timely_client_id?: number | null;
      /** Provider custom fields that should produce or resolve TIC resource relationships */
      custom_field_mappings?:
        | {
            /** Provider-scoped mapping identifier */
            id: string;
            /** Provider custom field identifier */
            field_id: string;
            /** The TIC resource type produced from this provider custom field */
            target_resource_type: "client";
            /** Provider-specific context required to read this field again during import; providers validate their executable context shape before using a mapping */
            context?: {
              [key: string]: string | number | boolean;
            };
          }[]
        | null;
      /** Should time entries be synced back to the external system (e.g., Jira worklogs)? */
      sync_time_entries?: boolean | null;
      /** Add all workspace users to imported projects */
      project_add_all_workspace_users?: boolean;
      /** Replace vs merge project users on update */
      project_replace_users_on_update?: boolean;
      /** Send invites when adding users to projects */
      project_send_invites?: boolean;
      /** Set required_labels flag on imported projects */
      project_require_labels?: boolean;
      /** When tasks include assignees that are not members of the project in Timely, automatically add them to the project before importing the task. */
      project_auto_add_assignees_to_projects?: boolean;
      /** Default billing rate type for new projects */
      project_default_rate_type?: "project" | "user" | "non-billable";
      /** When enabled, users only see tasks they have access to via their personal ClickUp connection (direct assignee, ancestor task assignee, or project member). Fail-closed: users without a personal connection see no tasks. */
      restrict_tasks_to_assignees?: boolean | null;
    };
    /** Who can access imported data */
    imported_data_access?: "default" | "everyone";
  };
};
export type ResetConnectionIdApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type ResetConnectionIdApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type DisconnectConnectionIdApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type DisconnectConnectionIdApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type DeleteConnectionIdApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type DeleteConnectionIdApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type GetConnectionActivitiesApiResponse = /** status 200 200 */ {
  activities: {
    /** Connection Activity ID */
    id: string | null;
    metadata: {
      /** When the activity occurred */
      when?: string;
      /** If the activity had an error */
      error?: boolean | string;
      lastXhr?: {
        /** The last URL called on this operation */
        url: string;
        eTag: string | null;
        when: string;
        eTags: string[];
        status: number;
        rateLimit: ((string | null) | (number | null)) | null;
        lastModified: string;
        lastRecordId: string | number | (string | null);
        firstRecordId: string | number | (string | null);
        rateLimitRemaining: string | number | (string | null);
        firstFewRecordsFingerprint?: string | number;
      };
      operationId?:
        | (
            | "importClients"
            | "importClient"
            | "importProjects"
            | "importProject"
            | "importProjectPermissions"
            | "importTasks"
            | "importTask"
            | "importLabels"
            | "importTeams"
            | "importTeam"
            | "importOrganizations"
            | "importOrganization"
            | "importIdentities"
            | "importIdentity"
            | "importPullRequests"
            | "importPullRequest"
            | "importMemories"
            | "syncWebhookDefinitions"
            | "syncWebhooks"
            | "handleIncomingWebhook"
            | "getCustomSettingsFields"
          )
        | (
            | "importIdentityStorage"
            | "importIdentitiesStorage"
            | "syncWebhookDefinitionsStorage"
            | "syncWebhooksStorage"
            | "upsertResourcesAndAssociations"
            | "upsertMemoriesAndAssociations"
            | "importMemoriesStorage"
          )
        | ("initialize" | "synchronize")
        | "getConnectionDetails"
        | "initAuthSession"
        | "forceFullImport"
        | "reset"
        | ("DataDiffCreated" | "DataDiffProcessed");
      executionSeconds?: string;
    };
    /** When the record was created */
    created_at: string;
    /** Connection ID */
    connection_id: string;
    operation:
      | (
          | "importClients"
          | "importClient"
          | "importProjects"
          | "importProject"
          | "importProjectPermissions"
          | "importTasks"
          | "importTask"
          | "importLabels"
          | "importTeams"
          | "importTeam"
          | "importOrganizations"
          | "importOrganization"
          | "importIdentities"
          | "importIdentity"
          | "importPullRequests"
          | "importPullRequest"
          | "importMemories"
          | "syncWebhookDefinitions"
          | "syncWebhooks"
          | "handleIncomingWebhook"
          | "getCustomSettingsFields"
        )
      | (
          | "importIdentityStorage"
          | "importIdentitiesStorage"
          | "syncWebhookDefinitionsStorage"
          | "syncWebhooksStorage"
          | "upsertResourcesAndAssociations"
          | "upsertMemoriesAndAssociations"
          | "importMemoriesStorage"
        )
      | ("initialize" | "synchronize")
      | "getConnectionDetails"
      | "initAuthSession"
      | "forceFullImport"
      | "reset"
      | ("DataDiffCreated" | "DataDiffProcessed");
    success: boolean;
    /** TIC account ID */
    account_id: string;
    subscription_id: ((string | null) | (number | null)) | null;
    connections: {
      tool_id: string;
      managing_user_id: string;
    };
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
  };
};
export type GetConnectionActivitiesApiArg = {
  /** Required: Filter activities by connection */
  connectionId: string;
  /** Filter by tool */
  toolId?: string;
  /** Account ID */
  accountId?: string;
  /** Page number */
  page?: number | null;
  /** Results per page */
  limit?: number | null;
};
export type GetConnectionWebhooksApiResponse = /** status 200 200 */ {
  webhook_key: string;
  metadata: {
    name: string | null;
    events: string[];
    conditions:
      | (
          | (string | null)
          | ({
              [key: string]: any;
            } | null)
        )
      | null;
    expires_every_num_days?: number;
    [key: string]: any;
  };
  destination_url: string;
  id: string;
  subscription_id: string;
  secret?: string | null;
  /** Whether the webhook subscription is currently active */
  active: boolean;
  installed_at: string | null;
  uninstalled_at: string | null;
  expires_at: string | null;
  external_id?: string | null;
  last_success_at: string | null;
  last_failure_at: string | null;
  last_failure_reason: string | null;
  last_recieved_payload: {
    [key: string]: any;
  } | null;
  updated_at: string;
  crupdated_payload?: {
    [key: string]: any;
  } | null;
}[];
export type GetConnectionWebhooksApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type TakeoverWebhooksApiResponse = /** status 200 200 */ {
  message: string;
  deletedWebhooks?: {
    id: string | number;
    url: string;
  }[];
  syncResult?: {
    [key: string]: any;
  } | null;
};
export type TakeoverWebhooksApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type GetConnectionProviderCustomSettingsFieldsApiResponse = /** status 200 200 */ {
  form_fields: {
    /** Human-readable field label shown in provider-generated UI */
    label: string;
    /** Stable provider field identifier in the active form context */
    fieldName: string;
    /** Connection settings array/object key to receive this field value when different from fieldName */
    settingsFieldName?: string;
    /** Frontend input type, e.g. text or select */
    inputType?: string;
    /** Should only be used if we have a good idea of what the value will be. */
    defaultValue?: ((string | null) | (number | null) | (boolean | null)) | null;
    /** Inline text description */
    description?: string;
    /** Validation and display config for the setup field */
    config?: {
      /** Regex pattern for string validation */
      pattern?: string;
      /** Whether the field is disabled */
      disabled?: boolean;
      /** Whether a non-empty value is required */
      required?: boolean;
      /** Minimum string length */
      minLength?: number;
      /** Maximum string length */
      maxLength?: number;
    };
    /** Selectable options for select-like input types */
    options?: {
      /** Human-readable option label shown in provider-generated UI */
      label: string;
      /** Value saved for this option by provider-generated UI */
      value: any | null;
      /** Optional help text for this option */
      description?: string;
    }[];
  }[];
};
export type GetConnectionProviderCustomSettingsFieldsApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type ReinstallConnectionWebhooksApiResponse = /** status 200 200 */ {
  message: string;
  /** Log correlation id for the background reinstall task (fire-and-forget) */
  job_id: string;
};
export type ReinstallConnectionWebhooksApiArg = {
  /** Connection ID */
  connectionId: string;
};
export type GetResourcesByTypeApiResponse = /** status 200 200 */ {
  resources: (
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          /** Resource color (hex or name) */
          color?: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
        };
        type: "organization";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
      }
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          /** Resource color (hex or name) */
          color?: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
        };
        type: "client";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
      }
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          /** Resource color (hex or name) */
          color?: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
        };
        type: "project";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
      }
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          /** Resource color (hex or name) */
          color?: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
        };
        type: "task";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
        /** Timely project identifier this task maps to, when available */
        timely_project_id?: number | null;
      }
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          color: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
          emoji: string | null;
        };
        type: "tag";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
      }
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          /** Resource color (hex or name) */
          color?: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
        };
        type: "team";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
      }
    | {
        /** External source ID */
        external_id?: string | null;
        /** Unique resource identifier (synthetic URI) */
        uri: string;
        /** Resource title/name */
        title: string;
        /** URI of root organization resource */
        root_uri: string | null;
        /** URI of parent resource */
        parent_uri: string | null;
        /** Tool ID this resource belongs to */
        tool_id: string;
        /** Subscription behavior: auto, manual, or null */
        subscription_type: ("auto" | "manual") | null;
        /** User-facing web URL */
        url_html: string | null;
        /** Canonical API endpoint URL */
        url_api: string;
        /** TIC record creation timestamp */
        created_at: string;
        /** TIC record last-updated timestamp */
        updated_at: string;
        /** Resource start date */
        start_date: string | null;
        /** Resource end/due date */
        end_date: string | null;
        /** When resource was completed */
        completed_at: string | null;
        /** When resource was archived */
        archived_at: string | null;
        /** When resource was deleted */
        deleted_at: string | null;
        /** TIC resource ID */
        id: string;
        /** TIC ID of parent resource */
        parent_id: string | null;
        /** TIC ID of root organization */
        root_id: string | null;
        metadata: {
          /** Provider-specific resource type name */
          external_type: string;
          /** Human-readable external ID (e.g., PROJ-123) */
          external_code?: string | null;
          /** Resource description or body text */
          description: string | null;
          /** Resource-specific icon URL */
          icon_url: string | null;
          /** Whether resource supports webhook subscriptions */
          supports_webhooks?: boolean;
          /** Whether resource supports nested subtasks/subitems */
          supports_subitems?: boolean | null;
          /** Resource color (hex or name) */
          color?: string | null;
          /** Associated tags/labels */
          tags?:
            | {
                /** External tag ID from provider */
                external_id: string;
                /** TIC synthetic URI for the tag */
                uri: string;
                /** Tag display name */
                title?: string | null;
              }[]
            | null;
          /** Primary project reference for task resolution */
          project?: {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          } | null;
          /** Secondary project references for multi-project tasks */
          additional_projects?:
            | {
                /** External project ID from provider */
                external_id: string;
                /** TIC synthetic URI for the project */
                uri: string;
              }[]
            | null;
          /** Estimated time in minutes */
          estimated_minutes?: number | null;
          /** Stored client reference from custom field mapping */
          client?: {
            /** Stored TIC client resource URI referenced by this task */
            uri: string;
            /** Stored TIC client external_id, included for diagnostics/provenance */
            external_id?: string;
            /** How this task was linked to the stored client */
            source: {
              /** Provider that produced the custom-field client reference */
              provider: string;
              /** connection.settings.custom_field_mappings[].id used for this match */
              mapping_id: string;
              /** Provider custom field identifier used for this match */
              field_id: string;
              /** Provider option identifier used for stored client identity */
              option_id: string;
              /** Provider-specific mapping context snapshot used to rediscover the field */
              context?: {
                [key: string]: string | number | boolean;
              };
              /** Provider option label snapshot */
              option_label?: string | null;
            };
          } | null;
          /** Timely side effects this resource is explicitly allowed to trigger */
          allowed_side_effects?: "project_templates"[];
        };
        type: "pull_request";
        tool: {
          /** Tool ID */
          id: string;
          /** Tool title */
          title: string;
          /** Tool icon URL */
          icon_url?: string | null;
          /** Raw tool data */
          raw?: string | null;
        };
      }
  )[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
  };
};
export type GetResourcesByTypeApiArg = {
  /** The type of resource to fetch. Defaults to `all` if not provided. */
  resourceType:
    | ("organization" | "team" | "client" | "project" | "task" | "tag" | "pull_request")
    | "all";
  /** The TIC `account.id` */
  accountId: string;
  /** Connection ID */
  connectionId?: string;
  /** Page # records */
  page?: number | null;
  /** Limit # records */
  limit?: number | null;
  /** The field to order the results by. Defaults to `updated_at`. */
  orderBy?: "title" | "created_at" | "updated_at";
  /** The direction to order the results by. Defaults to `desc`. */
  orderDirection?: "asc" | "desc";
  /** A search term to filter the results by */
  search?: string;
  /** The ID of the tool to filter the results by */
  toolId?: string;
  /** Filter to specific resource IDs */
  ids?: string[];
  /** Filter to specific resource URIs */
  uris?: string[];
};
export type GetTasksApiResponse = /** status 200 200 */ {
  tasks: {
    /** External source ID */
    external_id?: string | null;
    /** Unique resource identifier (synthetic URI) */
    uri: string;
    /** Resource title/name */
    title: string;
    /** URI of root organization resource */
    root_uri: string | null;
    /** URI of parent resource */
    parent_uri: string | null;
    /** Tool ID this resource belongs to */
    tool_id: string;
    /** Subscription behavior: auto, manual, or null */
    subscription_type: ("auto" | "manual") | null;
    /** User-facing web URL */
    url_html: string | null;
    /** Canonical API endpoint URL */
    url_api: string;
    /** TIC record creation timestamp */
    created_at: string;
    /** TIC record last-updated timestamp */
    updated_at: string;
    /** Resource start date */
    start_date: string | null;
    /** Resource end/due date */
    end_date: string | null;
    /** When resource was completed */
    completed_at: string | null;
    /** When resource was archived */
    archived_at: string | null;
    /** When resource was deleted */
    deleted_at: string | null;
    /** TIC resource ID */
    id: string;
    /** TIC ID of parent resource */
    parent_id: string | null;
    /** TIC ID of root organization */
    root_id: string | null;
    metadata: {
      /** Provider-specific resource type name */
      external_type: string;
      /** Human-readable external ID (e.g., PROJ-123) */
      external_code?: string | null;
      /** Resource description or body text */
      description: string | null;
      /** Resource-specific icon URL */
      icon_url: string | null;
      /** Whether resource supports webhook subscriptions */
      supports_webhooks?: boolean;
      /** Whether resource supports nested subtasks/subitems */
      supports_subitems?: boolean | null;
      /** Resource color (hex or name) */
      color?: string | null;
      /** Associated tags/labels */
      tags?:
        | {
            /** External tag ID from provider */
            external_id: string;
            /** TIC synthetic URI for the tag */
            uri: string;
            /** Tag display name */
            title?: string | null;
          }[]
        | null;
      /** Primary project reference for task resolution */
      project?: {
        /** External project ID from provider */
        external_id: string;
        /** TIC synthetic URI for the project */
        uri: string;
      } | null;
      /** Secondary project references for multi-project tasks */
      additional_projects?:
        | {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          }[]
        | null;
      /** Estimated time in minutes */
      estimated_minutes?: number | null;
      /** Stored client reference from custom field mapping */
      client?: {
        /** Stored TIC client resource URI referenced by this task */
        uri: string;
        /** Stored TIC client external_id, included for diagnostics/provenance */
        external_id?: string;
        /** How this task was linked to the stored client */
        source: {
          /** Provider that produced the custom-field client reference */
          provider: string;
          /** connection.settings.custom_field_mappings[].id used for this match */
          mapping_id: string;
          /** Provider custom field identifier used for this match */
          field_id: string;
          /** Provider option identifier used for stored client identity */
          option_id: string;
          /** Provider-specific mapping context snapshot used to rediscover the field */
          context?: {
            [key: string]: string | number | boolean;
          };
          /** Provider option label snapshot */
          option_label?: string | null;
        };
      } | null;
      /** Timely side effects this resource is explicitly allowed to trigger */
      allowed_side_effects?: "project_templates"[];
    };
    type: "task";
    tool: {
      /** Tool ID */
      id: string;
      /** Tool title */
      title: string;
      /** Tool icon URL */
      icon_url?: string | null;
      /** Raw tool data */
      raw?: string | null;
    };
    /** Timely project identifier this task maps to, when available */
    timely_project_id?: number | null;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
  };
};
export type GetTasksApiArg = {
  /** The TIC `account.id` */
  accountId: string;
  /** Text search query */
  search?: string;
  /** Filter by tool ID */
  toolId?: string;
  /** Include soft-deleted tasks in results */
  includeDeleted?: boolean | null;
  /** Maximum number of results to return per page (1-250, default: 50) */
  limit?: number;
  /** Page number for pagination (default: 1) */
  page?: number;
};
export type SearchTasksApiResponse = /** status 200 200 */ {
  tasks: {
    /** External source ID */
    external_id?: string | null;
    /** Unique resource identifier (synthetic URI) */
    uri: string;
    /** Resource title/name */
    title: string;
    /** URI of root organization resource */
    root_uri: string | null;
    /** URI of parent resource */
    parent_uri: string | null;
    /** Tool ID this resource belongs to */
    tool_id: string;
    /** Subscription behavior: auto, manual, or null */
    subscription_type: ("auto" | "manual") | null;
    /** User-facing web URL */
    url_html: string | null;
    /** Canonical API endpoint URL */
    url_api: string;
    /** TIC record creation timestamp */
    created_at: string;
    /** TIC record last-updated timestamp */
    updated_at: string;
    /** Resource start date */
    start_date: string | null;
    /** Resource end/due date */
    end_date: string | null;
    /** When resource was completed */
    completed_at: string | null;
    /** When resource was archived */
    archived_at: string | null;
    /** When resource was deleted */
    deleted_at: string | null;
    /** TIC resource ID */
    id: string;
    /** TIC ID of parent resource */
    parent_id: string | null;
    /** TIC ID of root organization */
    root_id: string | null;
    metadata: {
      /** Provider-specific resource type name */
      external_type: string;
      /** Human-readable external ID (e.g., PROJ-123) */
      external_code?: string | null;
      /** Resource description or body text */
      description: string | null;
      /** Resource-specific icon URL */
      icon_url: string | null;
      /** Whether resource supports webhook subscriptions */
      supports_webhooks?: boolean;
      /** Whether resource supports nested subtasks/subitems */
      supports_subitems?: boolean | null;
      /** Resource color (hex or name) */
      color?: string | null;
      /** Associated tags/labels */
      tags?:
        | {
            /** External tag ID from provider */
            external_id: string;
            /** TIC synthetic URI for the tag */
            uri: string;
            /** Tag display name */
            title?: string | null;
          }[]
        | null;
      /** Primary project reference for task resolution */
      project?: {
        /** External project ID from provider */
        external_id: string;
        /** TIC synthetic URI for the project */
        uri: string;
      } | null;
      /** Secondary project references for multi-project tasks */
      additional_projects?:
        | {
            /** External project ID from provider */
            external_id: string;
            /** TIC synthetic URI for the project */
            uri: string;
          }[]
        | null;
      /** Estimated time in minutes */
      estimated_minutes?: number | null;
      /** Stored client reference from custom field mapping */
      client?: {
        /** Stored TIC client resource URI referenced by this task */
        uri: string;
        /** Stored TIC client external_id, included for diagnostics/provenance */
        external_id?: string;
        /** How this task was linked to the stored client */
        source: {
          /** Provider that produced the custom-field client reference */
          provider: string;
          /** connection.settings.custom_field_mappings[].id used for this match */
          mapping_id: string;
          /** Provider custom field identifier used for this match */
          field_id: string;
          /** Provider option identifier used for stored client identity */
          option_id: string;
          /** Provider-specific mapping context snapshot used to rediscover the field */
          context?: {
            [key: string]: string | number | boolean;
          };
          /** Provider option label snapshot */
          option_label?: string | null;
        };
      } | null;
      /** Timely side effects this resource is explicitly allowed to trigger */
      allowed_side_effects?: "project_templates"[];
    };
    type: "task";
    tool: {
      /** Tool ID */
      id: string;
      /** Tool title */
      title: string;
      /** Tool icon URL */
      icon_url?: string | null;
      /** Raw tool data */
      raw?: string | null;
    };
    /** Timely project identifier this task maps to, when available */
    timely_project_id?: number | null;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
  };
};
export type SearchTasksApiArg = {
  /** Body */
  body: {
    /** The TIC `account.id` */
    accountId: string;
    /** Filter to specific resource IDs */
    ids?: string[];
    /** Filter to specific resource URIs */
    uris?: string[];
    /** Text search query */
    search?: string;
    /** Filter by tool ID */
    toolId?: string;
    /** Include soft-deleted tasks in results */
    includeDeleted?: boolean;
    limit?: number;
    page?: number;
  };
};
export type GetNotificationsApiResponse = /** status 200 200 */ {
  notifications: {
    id: string;
    event:
      | "user_joined_tic"
      | "account_provider_connected"
      | "personal_provider_connected"
      | "provider_sync_completed"
      | "tracker_session_flagged_inactive"
      | "timesheet_reminder"
      | "autosheet_auto_send_paused"
      | "provider_authentication_failed"
      | "provider_reconnect_required";
    message: string;
    created_at: string;
    expired_at?: string | null;
    delivery_methods?: ("email" | "tracker" | "in_app")[];
    metadata?: {
      priority?: "high" | "medium" | "low";
      audience?: "global" | "account" | "user";
      variant?: "default" | "success" | "warning" | "error";
      layout?: "default" | "provider" | "tracker";
      /** The scope of the integration */
      provider_scope?: "personal" | "account";
      job_queue_id?: string;
      date?: string;
      entries?: {
        /** Project name (undefined for unassigned entries) */
        name?: string;
        clientName?: string;
        durationMinutes: number;
        /** Start datetime with timezone (optional if no time blocks) */
        from?: string;
        /** End datetime with timezone (optional if no time blocks) */
        to?: string;
        note?: string;
        color: string;
        tags?: string[];
        /** Preferred time format: 12-hour or 24-hour */
        timeFormat?: "12" | "24";
      }[];
      timesheetLink?: string;
      unsubscribeLink?: string;
      isUnassignedOnly?: boolean;
      totalUnassignedMinutes?: number;
      deviceHostname?: string;
      daysSinceUpload?: number;
      showStagingBanner?: boolean;
      daysSinceLastActivity?: number;
      autosheetLink?: string;
    } | null;
    account_id: string | null;
    tool: {
      /** Tool ID */
      id: string;
      /** Tool title */
      title: string;
      /** Tool icon URL */
      icon_url?: string | null;
      /** Raw tool data */
      raw?: string | null;
    } | null;
    state: {
      id: string;
      seen_at: string | null;
      dismissed_at: string | null;
    } | null;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
  };
};
export type GetNotificationsApiArg = {
  /** TIC account ID */
  accountId?: string;
  /** User ID */
  userId?: string;
  /** When set, will return personal notifications as well, even in the context of another `account_id` */
  personalAccountId?: string;
  /** Notification ID */
  notificationId?: string;
  /** Page # records */
  page?: number | null;
  /** Limit # records */
  limit?: number | null;
};
export type BatchSetNotificationsStateApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type BatchSetNotificationsStateApiArg = {
  /** Body */
  body: {
    notification_states: {
      id?: string;
      user_id: string;
      notification_id: string;
      seen_at?: string | null;
      dismissed_at?: string | null;
    }[];
  };
};
export type GetTimesheetProposalsApiResponse = /** status 200 200 */ {
  proposals: {
    /** Unique identifier for the timesheet proposal */
    id: string;
    /** Date this proposal is for (YYYY-MM-DD) */
    date: string;
    /** Current status of the timesheet proposal */
    status?: "pending" | "accepted" | "rejected" | "edited";
    /** When the proposal was created */
    created_at: string;
    /** When the proposal was last updated */
    updated_at?: string | null;
    /** Number of entries in this proposal */
    entry_count?: number;
    /** Total duration of all items in minutes (calculated from started_at/ended_at) */
    total_duration_minutes?: number;
  }[];
  meta: {
    /** Number of records returned */
    count?: number;
    /** Total number of records */
    totalCount?: number;
    /** Description about the response, may include things like non-fatal errors made in the request (e.g, paginating past the last record) */
    message?: string | null;
  };
};
export type GetTimesheetProposalsApiArg = {
  /** The Timely `account.id` */
  timelyAccountId?: number;
  /** Current status of the timesheet proposal */
  status?: "pending" | "accepted" | "rejected" | "edited";
  /** Filter proposals on or after this date */
  dateFrom?: string;
  /** Filter proposals on or before this date */
  dateTo?: string;
  /** The Timely `user.id` */
  timelyUserId?: number;
  /** Page # records */
  page?: number | null;
  /** Limit # records */
  limit?: number | null;
};
export type CreateTimesheetProposalApiResponse = /** status 201 201 */ {
  proposal: {
    /** Unique identifier for the timesheet proposal */
    id: string;
    /** Date this proposal is for (YYYY-MM-DD) */
    date: string;
    /** Timely user ID this proposal is for */
    timely_user_id: number;
    /** TIC user ID (auth.users reference) */
    user_id: string;
    /** Timely account ID this proposal belongs to */
    timely_account_id: number;
    /** Current status of the timesheet proposal */
    status?: "pending" | "accepted" | "rejected" | "edited";
    /** Audit trail of all interactions with this proposal */
    log?: {
      /** When this action occurred */
      timestamp: string;
      /** Type of action performed on the proposal */
      action:
        | "created"
        | "status_changed"
        | "entry_added"
        | "entry_removed"
        | "entry_updated"
        | "entry_merged"
        | "item_updated"
        | "item_assigned"
        | "item_unassigned"
        | "ai_regenerated"
        | "note_regenerated";
      /** Additional details about the action */
      details?: {
        [key: string]: any;
      };
      /** User who performed the action (null if system-generated) */
      user_id?: string | null;
    }[];
    /** Additional metadata for the proposal */
    metadata?: {
      [key: string]: any;
    };
    /** When the proposal was created */
    created_at: string;
    /** When the proposal was last updated */
    updated_at?: string | null;
    /** When the proposal was soft-deleted (null if active) */
    deleted_at?: string | null;
    /** Daily entries within this proposal (loaded when fetching full proposal). Items are NOT nested under entries — they are returned at the top level via `items` and grouped by timestamp containment client-side. */
    entries?: {
      /** Unique identifier for the proposal entry */
      id: string;
      /** ID of the parent timesheet proposal */
      timesheet_proposal_id: string;
      /** Date this entry is for (YYYY-MM-DD) */
      date: string;
      /** Timely project ID (positive = assigned project, null = unassigned) */
      timely_project_id: number | null;
      /** Array of Timely label IDs associated with this entry */
      timely_label_ids?: number[];
      /** Entry timeline footprint start. Null for legacy empty entries. Always set for new entries. */
      started_at?: string | null;
      /** Entry timeline footprint end. Must satisfy started_at < ended_at when set. */
      ended_at?: string | null;
      /** Reference to logged hour entry ID in main system. NULL for draft entries, populated when entry is accepted/logged. */
      hour_id?: number | null;
      /** Note for this daily entry */
      note?: string | null;
      /** Duration in minutes for this entry. Can be set independently of time blocks. */
      duration_minutes?: number | null;
      /** Padding minutes for this entry, used to adjust total duration without changing item times */
      padding_minutes: number;
      /** Reference to an external resource (task, issue, etc.) that this entry is related to */
      resource_id?: string | null;
      /** Additional metadata for the entry */
      metadata?: {
        [key: string]: any;
      };
      /** When the entry was created */
      created_at: string;
      /** When the entry was last updated */
      updated_at?: string | null;
      /** When the entry was soft-deleted (null if active) */
      deleted_at?: string | null;
    }[];
    /** Every item belonging to this proposal — assigned (contained by some entry) and unassigned alike. Membership in a particular entry is derived client-side via timestamp containment. The `timesheet_proposal_entry_id` FK is provenance only and not authoritative for grouping. */
    items?: {
      /** Unique identifier for the entry item */
      id: string;
      /** Denormalized proposal reference; non-null. */
      timesheet_proposal_id: string;
      /** Provenance: the entry this item was originally grouped into at AI generation time. NOT current ownership — current ownership is derived from timestamp containment against entry ranges. */
      timesheet_proposal_entry_id: string | null;
      /** Start timestamp with timezone for this time block */
      started_at?: string | null;
      /** End timestamp with timezone for this time block */
      ended_at?: string | null;
      /** Array of memory UUIDs that contributed to this time block */
      memory_ids?: string[];
      /** Note for this specific time block */
      note?: string | null;
      /** Additional metadata for the item */
      metadata?: {
        [key: string]: any;
      };
      /** When the item was created */
      created_at: string;
      /** When the item was last updated */
      updated_at?: string | null;
      /** When the item was soft-deleted (null if active) */
      deleted_at?: string | null;
    }[];
  };
};
export type CreateTimesheetProposalApiArg = {
  /** Body */
  body: {
    date: string;
    /** The Timely `user.id` */
    timely_user_id: number;
    timely_account_id: number;
    metadata?: {
      [key: string]: any;
    };
    entries?: {
      date: string;
      /** Timely project ID (positive = assigned project, null = unassigned) */
      timely_project_id: number | null;
      timely_label_ids?: number[];
      hour_id?: number | null;
      note?: string | null;
      duration_minutes?: number | null;
      padding_minutes?: number;
      /** UUID identifier */
      resource_id?: string | null;
      metadata?: {
        [key: string]: any;
      };
      /** Entry timeline footprint start. Required for "claim empty time" entries with no items; null only for legacy empty entries with no timestamps. */
      started_at?: string | null;
      /** Entry timeline footprint end. See started_at. */
      ended_at?: string | null;
      items?: {
        /** DateTime with timezone */
        started_at?: string | null;
        /** DateTime with timezone */
        ended_at?: string | null;
        memory_ids?: string[];
        note?: string | null;
        metadata?: {
          [key: string]: any;
        };
      }[];
    }[];
  };
};
export type GetTimesheetProposalApiResponse = /** status 200 200 */ {
  proposal: {
    /** Unique identifier for the timesheet proposal */
    id: string;
    /** Date this proposal is for (YYYY-MM-DD) */
    date: string;
    /** Timely user ID this proposal is for */
    timely_user_id: number;
    /** TIC user ID (auth.users reference) */
    user_id: string;
    /** Timely account ID this proposal belongs to */
    timely_account_id: number;
    /** Current status of the timesheet proposal */
    status?: "pending" | "accepted" | "rejected" | "edited";
    /** Audit trail of all interactions with this proposal */
    log?: {
      /** When this action occurred */
      timestamp: string;
      /** Type of action performed on the proposal */
      action:
        | "created"
        | "status_changed"
        | "entry_added"
        | "entry_removed"
        | "entry_updated"
        | "entry_merged"
        | "item_updated"
        | "item_assigned"
        | "item_unassigned"
        | "ai_regenerated"
        | "note_regenerated";
      /** Additional details about the action */
      details?: {
        [key: string]: any;
      };
      /** User who performed the action (null if system-generated) */
      user_id?: string | null;
    }[];
    /** Additional metadata for the proposal */
    metadata?: {
      [key: string]: any;
    };
    /** When the proposal was created */
    created_at: string;
    /** When the proposal was last updated */
    updated_at?: string | null;
    /** When the proposal was soft-deleted (null if active) */
    deleted_at?: string | null;
    /** Daily entries within this proposal (loaded when fetching full proposal). Items are NOT nested under entries — they are returned at the top level via `items` and grouped by timestamp containment client-side. */
    entries?: {
      /** Unique identifier for the proposal entry */
      id: string;
      /** ID of the parent timesheet proposal */
      timesheet_proposal_id: string;
      /** Date this entry is for (YYYY-MM-DD) */
      date: string;
      /** Timely project ID (positive = assigned project, null = unassigned) */
      timely_project_id: number | null;
      /** Array of Timely label IDs associated with this entry */
      timely_label_ids?: number[];
      /** Entry timeline footprint start. Null for legacy empty entries. Always set for new entries. */
      started_at?: string | null;
      /** Entry timeline footprint end. Must satisfy started_at < ended_at when set. */
      ended_at?: string | null;
      /** Reference to logged hour entry ID in main system. NULL for draft entries, populated when entry is accepted/logged. */
      hour_id?: number | null;
      /** Note for this daily entry */
      note?: string | null;
      /** Duration in minutes for this entry. Can be set independently of time blocks. */
      duration_minutes?: number | null;
      /** Padding minutes for this entry, used to adjust total duration without changing item times */
      padding_minutes: number;
      /** Reference to an external resource (task, issue, etc.) that this entry is related to */
      resource_id?: string | null;
      /** Additional metadata for the entry */
      metadata?: {
        [key: string]: any;
      };
      /** When the entry was created */
      created_at: string;
      /** When the entry was last updated */
      updated_at?: string | null;
      /** When the entry was soft-deleted (null if active) */
      deleted_at?: string | null;
    }[];
    /** Every item belonging to this proposal — assigned (contained by some entry) and unassigned alike. Membership in a particular entry is derived client-side via timestamp containment. The `timesheet_proposal_entry_id` FK is provenance only and not authoritative for grouping. */
    items?: {
      /** Unique identifier for the entry item */
      id: string;
      /** Denormalized proposal reference; non-null. */
      timesheet_proposal_id: string;
      /** Provenance: the entry this item was originally grouped into at AI generation time. NOT current ownership — current ownership is derived from timestamp containment against entry ranges. */
      timesheet_proposal_entry_id: string | null;
      /** Start timestamp with timezone for this time block */
      started_at?: string | null;
      /** End timestamp with timezone for this time block */
      ended_at?: string | null;
      /** Array of memory UUIDs that contributed to this time block */
      memory_ids?: string[];
      /** Note for this specific time block */
      note?: string | null;
      /** Additional metadata for the item */
      metadata?: {
        [key: string]: any;
      };
      /** When the item was created */
      created_at: string;
      /** When the item was last updated */
      updated_at?: string | null;
      /** When the item was soft-deleted (null if active) */
      deleted_at?: string | null;
    }[];
  };
};
export type GetTimesheetProposalApiArg = {
  /** ID of the timesheet proposal to retrieve */
  id: string;
};
export type DeleteTimesheetProposalApiResponse = /** status 200 200 */ {
  code?: number;
  message: string;
  [key: string]: any;
};
export type DeleteTimesheetProposalApiArg = {
  /** ID of the timesheet proposal to delete */
  id: string;
};
export type UpdateTimesheetProposalStatusApiResponse = /** status 200 200 */ {
  proposal: {
    /** Unique identifier for the timesheet proposal */
    id: string;
    /** Date this proposal is for (YYYY-MM-DD) */
    date: string;
    /** Timely user ID this proposal is for */
    timely_user_id: number;
    /** TIC user ID (auth.users reference) */
    user_id: string;
    /** Timely account ID this proposal belongs to */
    timely_account_id: number;
    /** Current status of the timesheet proposal */
    status?: "pending" | "accepted" | "rejected" | "edited";
    /** Audit trail of all interactions with this proposal */
    log?: {
      /** When this action occurred */
      timestamp: string;
      /** Type of action performed on the proposal */
      action:
        | "created"
        | "status_changed"
        | "entry_added"
        | "entry_removed"
        | "entry_updated"
        | "entry_merged"
        | "item_updated"
        | "item_assigned"
        | "item_unassigned"
        | "ai_regenerated"
        | "note_regenerated";
      /** Additional details about the action */
      details?: {
        [key: string]: any;
      };
      /** User who performed the action (null if system-generated) */
      user_id?: string | null;
    }[];
    /** Additional metadata for the proposal */
    metadata?: {
      [key: string]: any;
    };
    /** When the proposal was created */
    created_at: string;
    /** When the proposal was last updated */
    updated_at?: string | null;
    /** When the proposal was soft-deleted (null if active) */
    deleted_at?: string | null;
    /** Daily entries within this proposal (loaded when fetching full proposal). Items are NOT nested under entries — they are returned at the top level via `items` and grouped by timestamp containment client-side. */
    entries?: {
      /** Unique identifier for the proposal entry */
      id: string;
      /** ID of the parent timesheet proposal */
      timesheet_proposal_id: string;
      /** Date this entry is for (YYYY-MM-DD) */
      date: string;
      /** Timely project ID (positive = assigned project, null = unassigned) */
      timely_project_id: number | null;
      /** Array of Timely label IDs associated with this entry */
      timely_label_ids?: number[];
      /** Entry timeline footprint start. Null for legacy empty entries. Always set for new entries. */
      started_at?: string | null;
      /** Entry timeline footprint end. Must satisfy started_at < ended_at when set. */
      ended_at?: string | null;
      /** Reference to logged hour entry ID in main system. NULL for draft entries, populated when entry is accepted/logged. */
      hour_id?: number | null;
      /** Note for this daily entry */
      note?: string | null;
      /** Duration in minutes for this entry. Can be set independently of time blocks. */
      duration_minutes?: number | null;
      /** Padding minutes for this entry, used to adjust total duration without changing item times */
      padding_minutes: number;
      /** Reference to an external resource (task, issue, etc.) that this entry is related to */
      resource_id?: string | null;
      /** Additional metadata for the entry */
      metadata?: {
        [key: string]: any;
      };
      /** When the entry was created */
      created_at: string;
      /** When the entry was last updated */
      updated_at?: string | null;
      /** When the entry was soft-deleted (null if active) */
      deleted_at?: string | null;
    }[];
    /** Every item belonging to this proposal — assigned (contained by some entry) and unassigned alike. Membership in a particular entry is derived client-side via timestamp containment. The `timesheet_proposal_entry_id` FK is provenance only and not authoritative for grouping. */
    items?: {
      /** Unique identifier for the entry item */
      id: string;
      /** Denormalized proposal reference; non-null. */
      timesheet_proposal_id: string;
      /** Provenance: the entry this item was originally grouped into at AI generation time. NOT current ownership — current ownership is derived from timestamp containment against entry ranges. */
      timesheet_proposal_entry_id: string | null;
      /** Start timestamp with timezone for this time block */
      started_at?: string | null;
      /** End timestamp with timezone for this time block */
      ended_at?: string | null;
      /** Array of memory UUIDs that contributed to this time block */
      memory_ids?: string[];
      /** Note for this specific time block */
      note?: string | null;
      /** Additional metadata for the item */
      metadata?: {
        [key: string]: any;
      };
      /** When the item was created */
      created_at: string;
      /** When the item was last updated */
      updated_at?: string | null;
      /** When the item was soft-deleted (null if active) */
      deleted_at?: string | null;
    }[];
  };
};
export type UpdateTimesheetProposalStatusApiArg = {
  /** ID of the timesheet proposal to update */
  id: string;
  /** Body */
  body: {
    /** Current status of the timesheet proposal */
    status: "pending" | "accepted" | "rejected" | "edited";
    /** Optional log entry to record with the status change */
    log_entry?: {
      /** When this action occurred */
      timestamp: string;
      /** Type of action performed on the proposal */
      action:
        | "created"
        | "status_changed"
        | "entry_added"
        | "entry_removed"
        | "entry_updated"
        | "entry_merged"
        | "item_updated"
        | "item_assigned"
        | "item_unassigned"
        | "ai_regenerated"
        | "note_regenerated";
      /** Additional details about the action */
      details?: {
        [key: string]: any;
      };
      /** User who performed the action (null if system-generated) */
      user_id?: string | null;
    };
  };
};
export type CreateTimesheetProposalEntryApiResponse = /** status 201 201 */ {
  entry: {
    /** Unique identifier for the proposal entry */
    id: string;
    /** ID of the parent timesheet proposal */
    timesheet_proposal_id: string;
    /** Date this entry is for (YYYY-MM-DD) */
    date: string;
    /** Timely project ID (positive = assigned project, null = unassigned) */
    timely_project_id: number | null;
    /** Array of Timely label IDs associated with this entry */
    timely_label_ids?: number[];
    /** Entry timeline footprint start. Null for legacy empty entries. Always set for new entries. */
    started_at?: string | null;
    /** Entry timeline footprint end. Must satisfy started_at < ended_at when set. */
    ended_at?: string | null;
    /** Reference to logged hour entry ID in main system. NULL for draft entries, populated when entry is accepted/logged. */
    hour_id?: number | null;
    /** Note for this daily entry */
    note?: string | null;
    /** Duration in minutes for this entry. Can be set independently of time blocks. */
    duration_minutes?: number | null;
    /** Padding minutes for this entry, used to adjust total duration without changing item times */
    padding_minutes: number;
    /** Reference to an external resource (task, issue, etc.) that this entry is related to */
    resource_id?: string | null;
    /** Additional metadata for the entry */
    metadata?: {
      [key: string]: any;
    };
    /** When the entry was created */
    created_at: string;
    /** When the entry was last updated */
    updated_at?: string | null;
    /** When the entry was soft-deleted (null if active) */
    deleted_at?: string | null;
  };
  /** Metadata about the operation that was performed */
  operation_metadata: {
    /** Whether an existing entry was reused instead of creating a new one (typically for unassigned entries) */
    was_reused: boolean;
    /** The action that was performed */
    action: "created_new_entry" | "reused_existing_entry";
    /** Human-readable description of what happened */
    message: string;
  };
};
export type CreateTimesheetProposalEntryApiArg = {
  /** ID of the timesheet proposal to add the entry to */
  proposalId: string;
  /** Body */
  body: {
    date: string;
    /** Timely project ID (positive = assigned project, null = unassigned) */
    timely_project_id: number | null;
    timely_label_ids?: number[];
    hour_id?: number | null;
    note?: string | null;
    duration_minutes?: number | null;
    padding_minutes?: number;
    /** UUID identifier */
    resource_id?: string | null;
    metadata?: {
      [key: string]: any;
    };
    /** Entry timeline footprint start. Required for "claim empty time" entries with no items; null only for legacy empty entries with no timestamps. */
    started_at?: string | null;
    /** Entry timeline footprint end. See started_at. */
    ended_at?: string | null;
  };
};
export type DeleteTimesheetProposalEntryApiResponse = /** status 200 200 */ {
  /** Confirmation message for the deletion */
  message: string;
  /** ID of the deleted entry */
  deleted_entry_id: string;
};
export type DeleteTimesheetProposalEntryApiArg = {
  /** ID of the proposal entry to delete */
  entryId: string;
};
export type PatchTimesheetProposalEntryApiResponse = /** status 200 200 */ {
  timely_project_id?: number;
  timely_label_ids?: number[];
  note?: string | null;
  duration_minutes?: number | null;
  padding_minutes?: number | null;
  hour_id?: number | null;
  /** UUID identifier */
  resource_id?: string | null;
  /** Entry timeline footprint start. Null only for legacy empty entries; non-null pairs (started_at, ended_at) must satisfy started_at < ended_at. */
  started_at?: string | null;
  /** Entry timeline footprint end. See started_at. */
  ended_at?: string | null;
  /** DateTime with timezone */
  updated_at?: string | null;
};
export type PatchTimesheetProposalEntryApiArg = {
  /** ID of the proposal entry to update */
  entryId: string;
  /** Body */
  body: {
    timely_project_id?: number;
    timely_label_ids?: number[];
    note?: string | null;
    duration_minutes?: number | null;
    padding_minutes?: number | null;
    hour_id?: number | null;
    /** UUID identifier */
    resource_id?: string | null;
    /** Entry timeline footprint start. Null only for legacy empty entries; non-null pairs (started_at, ended_at) must satisfy started_at < ended_at. */
    started_at?: string | null;
    /** Entry timeline footprint end. See started_at. */
    ended_at?: string | null;
    /** DateTime with timezone */
    updated_at?: string | null;
  };
};
export type TriggerTimesheetProposalGenerationApiResponse = /** status 202 202 */ {
  message: string;
  /** Background job ID for tracking generation progress */
  job_id?: string;
  /** Estimated time when generation will complete */
  estimated_completion_time?: string;
};
export type TriggerTimesheetProposalGenerationApiArg = {
  /** Body */
  body: {
    date: string;
    /** The Timely `user.id` */
    timely_user_id: number;
    timely_account_id: number;
    /** Mode of generation: manual (user-initiated) or auto (scheduled) */
    generation_mode?: "manual" | "auto";
    /** Whether to regenerate if a proposal already exists for this date */
    force_regenerate?: boolean;
    /** Amplitude browser session id for interactive generations. Propagated to the AI service so the backend-emitted Amplitude event joins the same user session. */
    session_id?: number | null;
    /** Additional parameters for AI generation, including optional AI service configuration */
    metadata?: {
      effort?: "none" | "low" | "medium";
      interval_minutes?: number;
      provider?: string;
      /** Language for AI-generated notes */
      note_language?:
        | "Arabic"
        | "Danish"
        | "Dutch"
        | "English"
        | "French"
        | "German"
        | "Italian"
        | "Japanese"
        | "Norwegian"
        | "Portuguese"
        | "Spanish"
        | "Swedish";
      [key: string]: any;
    };
  };
};
export type RegenerateEntryNotesApiResponse = /** status 202 202 */ {
  message: string;
  /** Background job ID for tracking regeneration progress */
  job_id?: string;
  /** Estimated time when note regeneration will complete */
  estimated_completion_time?: string;
};
export type RegenerateEntryNotesApiArg = {
  /** Body */
  body: {
    date: string;
    timely_account_id: number;
    /** The Timely `user.id` */
    timely_user_id: number;
    /** Optional entry ID to regenerate note for a single entry. If omitted, regenerates notes for all edited entries on the date. */
    entry_id?: string;
    /** Amplitude browser session id for interactive regenerations. Propagated to the AI service for backend-side Amplitude attribution. */
    session_id?: number | null;
    /** Additional parameters for AI note regeneration */
    metadata?: {
      /** Language for AI-generated notes */
      note_language?:
        | "Arabic"
        | "Danish"
        | "Dutch"
        | "English"
        | "French"
        | "German"
        | "Italian"
        | "Japanese"
        | "Norwegian"
        | "Portuguese"
        | "Spanish"
        | "Swedish";
      [key: string]: any;
    };
  };
};
export type GetProjectSuggestionsApiResponse = /** status 200 200 */ {
  /** Suggestion set ID */
  id: string;
  /** The Timely `account.id` */
  timely_account_id: number;
  /** Array of project suggestions */
  suggestions: {
    /** Project name */
    name: string;
    /** Project description with tool/site/keyword hints */
    description: string;
  }[];
  /** Current status of the project suggestion set */
  status: "pending" | "accepted" | "dismissed";
  /** Creation timestamp */
  created_at: string;
  /** Last update timestamp */
  updated_at: string | null;
}[];
export type GetProjectSuggestionsApiArg = {
  /** TIC account ID */
  accountId: string;
};
export type TriggerProjectSuggestionsApiResponse = /** status 202 202 */ {
  message: string;
};
export type TriggerProjectSuggestionsApiArg = {
  /** Body */
  triggerProjectSuggestions: {
    /** Timely account ID */
    timely_account_id: number;
    /** Industry of the account */
    industry: string;
    /** Primary use case for time tracking */
    use_case: string;
    /** Company name */
    company_name: string;
    /** User's job title/role. Optional — when present, it is used to personalize the AI-generated project suggestions. */
    role?: string;
  };
};
export type UpdateProjectSuggestionStatusApiResponse = /** status 200 200 */ {
  /** Suggestion set ID */
  id: string;
  /** The Timely `account.id` */
  timely_account_id: number;
  /** Array of project suggestions */
  suggestions: {
    /** Project name */
    name: string;
    /** Project description with tool/site/keyword hints */
    description: string;
  }[];
  /** Current status of the project suggestion set */
  status: "pending" | "accepted" | "dismissed";
  /** Creation timestamp */
  created_at: string;
  /** Last update timestamp */
  updated_at: string | null;
};
export type UpdateProjectSuggestionStatusApiArg = {
  /** TIC account ID */
  accountId: string;
  /** Project suggestion set ID */
  id: string;
  /** Body */
  updateProjectSuggestionStatus: {
    /** New status for the suggestion set */
    status: "accepted" | "dismissed";
  };
};
export const {
  useGetMemoryConfigQuery,
  useSaveMemoryConfigMutation,
  useGetMemoriesQuery,
  useDeleteMemoriesMutation,
  useGetAiPredictionsInDateRangeQuery,
  useRejectAiPredictionMutation,
  useGetAiPredictionStatusForDateRangeQuery,
  useSetAiPredictionStatusMutation,
  useRefreshAiPredictionsInDateRangeMutation,
  useRetrainAiModelMutation,
  useResetAiModelMutation,
  useRequestHourNoteGenerationMutation,
  useRequestSuggestionNoteGenerationMutation,
  useGetAiPreferencesQuery,
  useSaveAiPreferencesMutation,
  useGetAiWorkspacePreferencesQuery,
  useSaveAiWorkspacePreferencesMutation,
  useGetAiWorkspaceDefaultsQuery,
  useSaveAiWorkspaceDefaultsMutation,
  useGetAssistantResponseQuery,
  useResetEverythingAiMutation,
  useGetToolsQuery,
  useGetToolIdQuery,
  useGetToolConfigsQuery,
  useResetAllToolConfigsMutation,
  useGetDefaultToolConfigsQuery,
  useSaveToolConfigMutation,
  useDeleteToolConfigMutation,
  useUpdateBatchOfSubscriptionsMutation,
  useGetSubscribableResourcesQuery,
  useProviderOperationIdMutation,
  useGetIntegrationsQuery,
  useGetIntegrationDetailsQuery,
  useFinalizeIntegrationSetupMutation,
  useGetDiffPreviewQuery,
  useRegenerateFullDiffMutation,
  useGetConnectionJobsQuery,
  useGetConnectionSyncRunProgressQuery,
  useGetConnectionSyncRunsQuery,
  useGetDiffsListQuery,
  useGetDiffDetailsQuery,
  useUpdateConnectionIdMutation,
  useResetConnectionIdMutation,
  useDisconnectConnectionIdMutation,
  useDeleteConnectionIdMutation,
  useGetConnectionActivitiesQuery,
  useGetConnectionWebhooksQuery,
  useTakeoverWebhooksMutation,
  useGetConnectionProviderCustomSettingsFieldsQuery,
  useReinstallConnectionWebhooksMutation,
  useGetResourcesByTypeQuery,
  useGetTasksQuery,
  useSearchTasksMutation,
  useGetNotificationsQuery,
  useBatchSetNotificationsStateMutation,
  useGetTimesheetProposalsQuery,
  useCreateTimesheetProposalMutation,
  useGetTimesheetProposalQuery,
  useDeleteTimesheetProposalMutation,
  useUpdateTimesheetProposalStatusMutation,
  useCreateTimesheetProposalEntryMutation,
  useDeleteTimesheetProposalEntryMutation,
  usePatchTimesheetProposalEntryMutation,
  useTriggerTimesheetProposalGenerationMutation,
  useRegenerateEntryNotesMutation,
  useGetProjectSuggestionsQuery,
  useTriggerProjectSuggestionsMutation,
  useUpdateProjectSuggestionStatusMutation,
} = injectedRtkApi;
